import { 
	Box, Button, Snackbar, Table, 
	TableBody, TableCell, TableHead, TableRow ,TextField
} from "@material-ui/core"; 
import Autocomplete from '@material-ui/lab/Autocomplete';
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline"; 
import { exportInvoicePdf } from "../../Components/invoicePdf";
import AddBoxIcon from "@material-ui/icons/AddBox"; 
import { makeStyles } from "@material-ui/core/styles"; 
import Alert from "@material-ui/lab/Alert"; 
import Dialog from "@material-ui/core/Dialog"; 
import DialogActions from "@material-ui/core/DialogActions"; 
import DialogContent from "@material-ui/core/DialogContent"; 
import DialogContentText from "@material-ui/core/DialogContentText"; 
import DialogTitle from "@material-ui/core/DialogTitle";
import TableContainer from '@material-ui/core/TableContainer'; 
import './CheckOut.scss';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import apiClient, { getAccessToken } from '../../apiClient';
import React, { useState, useEffect } from 'react';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import InputLabel from '@material-ui/core/InputLabel';
import Checkbox from '@material-ui/core/Checkbox';
import DateFnsUtils from '@date-io/date-fns';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { TableFooter } from '@material-ui/core';
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import moment from 'moment';
import Spinner from '../Spinner';
import { publishNotification } from '../Notification/notificationService';
import { useLocation } from 'react-router-dom';
import TransactionHeader from '../../Components/TransactionHeader';
import InvoiceLineRows from '../../Components/InvoiceLineRows';
import { SHOW_PAYMENT_FEE } from '../../Components/displaySettings';

/** Invoice/checkout autocomplete: active items only (not archived). */
const CHECKOUT_ITEM_AUTOCOMPLETE_PARAMS = {
	forAutocomplete: 1,
	autocompleteEligible: 'strict',
};

function checkoutItemCatalogRequestConfig(accessToken) {
	return {
		params: { ...CHECKOUT_ITEM_AUTOCOMPLETE_PARAMS, _ts: Date.now() },
		headers: {
			Authorization: `Bearer ${accessToken || ''}`,
			'Cache-Control': 'no-cache',
			Pragma: 'no-cache',
		},
	};
}

function isCheckoutItemActive(item) {
	if (item == null || typeof item !== 'object') return false;
	const a = item.Active;
	return !(
		a === false ||
		a === 0 ||
		String(a).toLowerCase() === 'false' ||
		String(a) === '0'
	);
}

function filterCheckoutAutocompleteItems(list) {
	return (list || []).filter(isCheckoutItemActive);
}

function getDefaultLocationIdFromList(list) {
	const hit = (list || []).find(
		(x) =>
			x &&
			(x.IsDefault === 1 ||
				x.IsDefault === true ||
				String(x.IsDefault).toLowerCase() === 'true')
	);
	return hit ? hit.ItemLocationId : '';
}

function getTransactionLocationIdFromItem(item) {
	if (!item) return '';
	const raw =
		item.LocationId != null && item.LocationId !== ''
			? item.LocationId
			: item.locationId != null && item.locationId !== ''
				? item.locationId
				: '';
	if (raw === '' || raw == null) return '';
	const locNum = Number(raw);
	return locNum > 0 && !Number.isNaN(locNum) ? locNum : '';
}

function ensureCheckoutLocationOptionForTransaction(opts, locationId, locationCatalog) {
	const locNum = Number(locationId);
	if (!locNum || Number.isNaN(locNum)) return opts || [];
	const list = opts || [];
	if (list.some((o) => Number(o.LocationId) === locNum)) return list;
	const hit = (locationCatalog || []).find(
		(x) => Number(x.ItemLocationId) === locNum
	);
	return [
		...list,
		{
			LocationId: locNum,
			LocationName: hit?.LocationName || 'Location',
			Quantity: 0,
		},
	];
}

function formatCheckoutQtyLabel(v) {
	return Number(parseFloat(v) || 0).toFixed(2);
}

/**
 * Label for the selected location(s): shows what is available there (not the
 * quantity typed in the row). With several locations, also how much is taken
 * from each, e.g. "Main: 3.00 of 5.00 available, Back: 2.00 of 10.00 available".
 */
function formatCheckoutLocationRenderLabel(row, selectedIds, getAvailableQty) {
	const ids = selectedIds || [];
	if (!ids.length) return 'Select location(s)';
	const options = row.locationOptions || [];
	const allocations = row.locationAllocations || [];
	return ids
		.map((id) => {
			const opt = options.find((o) => Number(o.LocationId) === Number(id));
			const alloc = allocations.find((a) => Number(a.locationId) === Number(id));
			const name = opt?.LocationName || alloc?.locationName || `Location ${id}`;
			const available = getAvailableQty
				? getAvailableQty(opt || { LocationId: id, Quantity: 0 })
				: parseFloat(opt?.Quantity) || 0;
			if (ids.length > 1 && alloc) {
				return `${name}: ${formatCheckoutQtyLabel(alloc.quantity)} of ${formatCheckoutQtyLabel(available)} available`;
			}
			return `${name} (${formatCheckoutQtyLabel(available)} available)`;
		})
		.join(', ');
}

function checkoutLocationHasStock(loc) {
	return (parseFloat(loc?.Quantity) || 0) > 0;
}

const checkoutLocationNoQtyMsg =
	'This location has no available quantity and cannot be selected.';

function resolveReturnLocationIdFromStock(stockRows, locationList, primaryLocationId) {
	const primary = Number(primaryLocationId);
	// Keep the location from the original transaction when present (e.g. invoice return).
	if (primary > 0) return primary;

	const ids = (stockRows || [])
		.map((s) => Number(s.LocationId))
		.filter((id) => id > 0);
	if (!ids.length) {
		const def = getDefaultLocationIdFromList(locationList);
		return def === '' || def == null ? '' : Number(def);
	}
	if (ids.length === 1) return ids[0];
	const def = getDefaultLocationIdFromList(locationList);
	if (def !== '' && def != null && ids.includes(Number(def))) return Number(def);
	return ids[0];
}

function ticketRowLocationFieldsFromTransaction(item, itemDetail, qtyField) {
	const qty = Math.abs(
		parseFloat(item?.Quantity ?? item?.[qtyField]) ||
			parseFloat(qtyField === 'checkinqty' ? item?.checkoutqty : item?.checkinqty) ||
			0
	);
	const locRaw = getTransactionLocationIdFromItem(item);
	const locNum = locRaw !== '' && locRaw != null ? Number(locRaw) : 0;
	return {
		locationId: locRaw,
		selectedLocationIds: locNum > 0 ? [locNum] : [],
		locationOptions: [],
		locationAllocations:
			locNum > 0 && qty > 0
				? [{ locationId: locNum, quantity: qty }]
				: [],
	};
}

function resolveLocationFieldsForTicketRow(row, stockOpts, locationCatalog, qtyField) {
	const field = qtyField || 'checkoutqty';
	const locId = resolveReturnLocationIdFromStock(stockOpts, locationCatalog, row.locationId);
	if (!locId) return null;
	const qty = Math.abs(parseFloat(row[field]) || 0);
	const hit = (stockOpts || []).find((o) => Number(o.LocationId) === Number(locId));
	const patch = { locationId: locId };
	if (qty > 0) {
		patch.locationAllocations = [
			{
				locationId: locId,
				locationName: hit?.LocationName || '',
				quantity: qty,
				availableQuantity: hit ? hit.Quantity : 0,
			},
		];
	}
	return patch;
}

function checkoutQtyFieldForAction(formAction) {
	return formAction === 'Return' ? 'checkinqty' : 'checkoutqty';
}

function getCheckoutOldQtyAtLocation(oldRow, locationId) {
	if (!oldRow) return 0;
	const locId = Number(locationId);
	if (!locId || Number.isNaN(locId)) return 0;
	const allocs = oldRow.locationAllocations || [];
	const hit = allocs.find((a) => Number(a.locationId) === locId);
	if (hit) return parseFloat(hit.quantity) || 0;
	const oldLocId =
		oldRow.locationId != null && oldRow.locationId !== ''
			? Number(oldRow.locationId)
			: 0;
	if (oldLocId === locId) {
		return parseFloat(oldRow.checkoutqty) || 0;
	}
	return 0;
}

function getCheckoutEditLocationEffectiveAvailable(apiQty, oldRow, locationId) {
	const base = parseFloat(apiQty) || 0;
	return base + getCheckoutOldQtyAtLocation(oldRow, locationId);
}

function syncCheckoutLocationAllocationsToQty(row, qtyRaw, editCreditAtLocation = 0) {
	const qty = parseFloat(qtyRaw) || 0;
	if (!row || qty <= 0) return row;
	const next = { ...row };
	const locId =
		next.locationId != null && next.locationId !== ''
			? Number(next.locationId)
			: 0;
	const selected = (next.selectedLocationIds || []).filter((id) => Number(id) > 0);
	const primaryLocId =
		locId > 0 ? locId : selected.length === 1 ? Number(selected[0]) : 0;
	if (!primaryLocId) return next;
	const allocs = Array.isArray(next.locationAllocations) ? next.locationAllocations : [];
	const prev = allocs.find((a) => Number(a.locationId) === primaryLocId) || allocs[0] || {};
	const hit = (next.locationOptions || []).find(
		(o) => Number(o.LocationId) === primaryLocId
	);
	const apiAvail =
		hit != null
			? parseFloat(hit.Quantity) || 0
			: prev.availableQuantity != null
				? parseFloat(prev.availableQuantity) || 0
				: 0;
	const effectiveAvail = apiAvail + (parseFloat(editCreditAtLocation) || 0);
	next.locationId = primaryLocId;
	next.locationAllocations = [
		{
			locationId: primaryLocId,
			locationName: prev.locationName || hit?.LocationName || '',
			quantity: qty,
			availableQuantity: effectiveAvail,
		},
	];
	if (!selected.length) {
		next.selectedLocationIds = [primaryLocId];
	} else if (!selected.includes(primaryLocId)) {
		next.selectedLocationIds = [primaryLocId];
	}
	return next;
}

function isCheckoutEditContext(tranAction, formAction) {
	if (tranAction !== 'edit') return false;
	if (formAction === 'Return' || formAction === 'Adjustment') return false;
	return formAction === 'CheckOut' || formAction === 'Reserve';
}

function cloneCheckoutLocationFields(locFields) {
	return {
		...locFields,
		selectedLocationIds: [...(locFields.selectedLocationIds || [])],
		locationAllocations: (locFields.locationAllocations || []).map((a) => ({ ...a })),
		locationOptions: [],
	};
}

function buildCheckoutRowFromTransactionItem(item, itemDetail, formAction, rowId) {
	const locFields = cloneCheckoutLocationFields(
		ticketRowLocationFieldsFromTransaction(
			item,
			itemDetail,
			checkoutQtyFieldForAction(formAction)
		)
	);
	return {
		id: rowId,
		itemid: item.ItemId,
		itemname: item.ItemName,
		// Sold-out / inactive items are not in the active catalog (itemDetail); use the ticket's stock value.
		qtyinstock: itemDetail?.Quantity ?? item.ItemQtyInStock ?? 0,
		checkinqty: item?.Quantity,
		checkoutqty: item.Quantity,
		returnQuantity: item.ReturnQuantity,
		returnTicketNumber: item.ReturnTicketNumber,
		priperunit: item.PricePerUnit,
		totpri: item.TotalPrice,
		itemnumber: item.ItemNumber,
		targetprice: item.TargetPrice,
		// Keep entity / category on the row: the post-submit invoice groups by them,
		// and sold-out items drop out of the active item catalog used as fallback.
		entityGroupName: item.EntityGroupName || itemDetail?.EntityGroupName || '',
		categoryName: item.CategoryName || itemDetail?.CategoryName || '',
		cost: itemDetail?.Cost ?? item.Cost,
		margin: itemDetail?.Margin ?? item.Margin,
		dynamicCost: itemDetail?.DynamicCost,
		paymentMethodId: item.PaymentMethodId,
		paymentFee: item.PaymentFee,
		isNonInventory:
			itemDetail &&
			(itemDetail.IsNonInventory === 1 || itemDetail.IsNonInventory === true),
		...locFields,
	};
}

function syncCheckoutRowLocationAllocations(row, tranAction, formAction) {
	if (!isCheckoutEditContext(tranAction, formAction)) return row;
	const qty =
		parseFloat(row.checkoutqty) ||
		parseFloat(row.checkinqty) ||
		0;
	if (
		row.locationId ||
		(row.selectedLocationIds || []).length === 1
	) {
		return syncCheckoutLocationAllocationsToQty(row, qty);
	}
	return row;
}

function resolveSubmitCheckoutQty(row, formAction) {
	if (formAction === 'Return') {
		const checkout = parseFloat(row.checkoutqty);
		const checkin = parseFloat(row.checkinqty);
		if (!Number.isNaN(checkout)) return checkout;
		if (!Number.isNaN(checkin)) return checkin;
		return parseFloat(row.Quantity) || 0;
	}
	const field = checkoutQtyFieldForAction(formAction);
	return (
		parseFloat(row[field]) ||
		parseFloat(row.checkoutqty) ||
		parseFloat(row.checkinqty) ||
		parseFloat(row.Quantity) ||
		0
	);
}

function syncReturnRowQtyFields(row, qtyRaw) {
	const qty = parseFloat(qtyRaw);
	if (Number.isNaN(qty)) return row;
	return { ...row, checkoutqty: qty, checkinqty: qty };
}

function normalizeCheckoutRowLocationForTransaction(row, locationCatalog, formAction) {
	const next = { ...row };
	const qtyField = checkoutQtyFieldForAction(formAction);
	const checkoutQty =
		parseFloat(next[qtyField]) ||
		parseFloat(next.checkoutqty) ||
		parseFloat(next.checkinqty) ||
		0;
	if (next.locationId != null && next.locationId !== '' && Number(next.locationId) > 0) {
		if (checkoutQty > 0) {
			return syncCheckoutLocationAllocationsToQty(next, checkoutQty);
		}
		return next;
	}
	const allocs = next.locationAllocations || [];
	if (allocs.length >= 1) {
		const primary =
			allocs.find((a) => (parseFloat(a.quantity) || 0) > 0) || allocs[0];
		if (primary && primary.locationId) {
			next.locationId = primary.locationId;
			if (checkoutQty > 0 && allocs.length === 1) {
				return syncCheckoutLocationAllocationsToQty(next, checkoutQty);
			}
			return next;
		}
	}
	const selected = (next.selectedLocationIds || []).filter((id) => Number(id) > 0);
	if (selected.length === 1) {
		next.locationId = selected[0];
		if (checkoutQty > 0) {
			return syncCheckoutLocationAllocationsToQty(next, checkoutQty);
		}
		return next;
	}
	const patch = resolveLocationFieldsForTicketRow(
		next,
		next.locationOptions || [],
		locationCatalog,
		qtyField
	);
	if (patch && patch.locationId) {
		Object.assign(next, patch);
		if (checkoutQty > 0) {
			return syncCheckoutLocationAllocationsToQty(next, checkoutQty);
		}
	}
	return next;
}

const useStyles = makeStyles({ 
	root: { 
		"& > *": { 
			borderBottom: "unset", 
		}, 
	}, 
	customTextField: {
		'& .MuiInputBase-root': {
		  backgroundColor: 'transparent', // Set background color to transparent
		},
	  },

	snackbar: { 
		bottom: "104px", 
	}, 
	table: {
		maxWidth: '100%', // Set to '100%' to make the table responsive
	  },
	  tableHeader: {
		backgroundColor: '#f2f2f2',
		fontWeight: 'bold',
	  },
	  tableRow: {
		'&:hover': {
		  backgroundColor: '#e0e0e0',
		},
	  },
	  tableCell: {
		borderBottom: '1px solid #dddddd',
		width:"150px !important",
	  },
	  tableCellEmbedded: {
		borderBottom: '1px solid #dddddd',
		width: 'auto',
		padding: '6px 8px',
		verticalAlign: 'middle',
	  },
	  tableEmbedded: {
		width: '100%',
		tableLayout: 'fixed',
	  },
	  rowDiv: {
		width:"1000px !important",
	  },
}); 

const TARGET_PRICE_MASK_CHAR = '*';
const COST_MASK_CHAR = '*';

function hasTargetPriceValue(value) {
  if (value === '' || value === null || value === undefined) return false;
  return Number.isFinite(parseFloat(value));
}

function formatTargetPriceDisplay(value) {
  const n = parseFloat(value);
  return Number.isFinite(n) ? n.toFixed(2) : '';
}

function maskTargetPriceDisplay(value) {
  const formatted = formatTargetPriceDisplay(value);
  if (!formatted) return '';
  return TARGET_PRICE_MASK_CHAR.repeat(formatted.length);
}

function getTargetPriceRowKey(row, index) {
  return `row-${index}`;
}

function hasCostValue(value) {
  if (value === '' || value === null || value === undefined) return false;
  return Number.isFinite(parseFloat(value));
}

function formatCostDisplay(value) {
  const n = parseFloat(value);
  return Number.isFinite(n) ? n.toFixed(2) : '';
}

function maskCostDisplay(value) {
  const formatted = formatCostDisplay(value);
  if (!formatted) return '';
  return COST_MASK_CHAR.repeat(formatted.length);
}

function getCostRowKey(row, index) {
  return `row-${index}`;
}

const parseCommissionNumber = (value) => {
  const n = parseFloat(value);
  return Number.isFinite(n) ? n : 0;
};

const getRowCheckoutQuantity = (item) =>
  parseCommissionNumber(item.checkoutqty ?? item.checkinqty ?? item.Quantity ?? 0);

const normalizeCommissionType = (type) => {
  const t = String(type || '').trim().toLowerCase();
  if (t === 'percentage' || t === 'percent' || t === 'profit') return 'Percentage';
  if (t === 'rate') return 'Rate';
  if (t === 'amount' || t === 'individual' || t === 'fixed') return 'Individual';
  return '';
};

const getCheckoutItemQty = (item) =>
  parseCommissionNumber(
    item?.checkoutqty ?? item?.Quantity ?? item?.checkinqty ?? item?.qty ?? 0
  );

const getCheckoutItemTotal = (item) =>
  parseCommissionNumber(item?.totpri ?? item?.TotalPrice ?? 0);

const getCheckoutItemUnitPrice = (item) =>
  parseCommissionNumber(item?.priperunit ?? item?.PricePerUnit ?? 0);

/** Rate + Individual are added to grand total; Percentage (profit) is subtracted. */
const resolveCommissionKind = (c) => {
  const raw = c?.commissionType ?? c?.Type ?? c?.type;
  const normalized = normalizeCommissionType(raw);
  if (normalized === 'Rate' || normalized === 'Individual') return 'fixed';
  if (normalized === 'Percentage') return 'profit';

  // Infer from value fields when Type is missing/ambiguous.
  const hasRate =
    (c?.rate != null && String(c.rate).trim() !== '') ||
    (c?.Rate != null && String(c.Rate).trim() !== '');
  const hasAmount =
    (c?.amount != null && String(c.amount).trim() !== '') ||
    (c?.Amount != null && String(c.Amount).trim() !== '');
  const hasPercent =
    (c?.percent != null && String(c.percent).trim() !== '') ||
    (c?.Percentage != null && String(c.Percentage).trim() !== '') ||
    (c?.percentage != null && String(c.percentage).trim() !== '');

  if (hasRate || hasAmount) return 'fixed';
  if (hasPercent) return 'profit';
  // Prefer addable (Rate/Individual behavior) so client prices get adjusted.
  return 'fixed';
};

const getCommissionLineAmountValue = (c, itemRows) => {
  let amount = parseCommissionNumber(c?.commissionAmount);
  if (amount > 0) return amount;

  const type = normalizeCommissionType(c?.commissionType ?? c?.Type ?? c?.type);
  if (type === 'Rate' || (type === '' && resolveCommissionKind(c) === 'fixed')) {
    const rate = parseCommissionNumber(c?.rate ?? c?.Rate);
    if (rate > 0 && itemRows?.length) {
      const totalQty = itemRows.reduce((sum, item) => sum + getCheckoutItemQty(item), 0);
      if (totalQty > 0) return Math.round(rate * totalQty * 100) / 100;
    }
  }
  if (type === 'Individual' || resolveCommissionKind(c) === 'fixed') {
    const individual = parseCommissionNumber(c?.amount ?? c?.Amount);
    if (individual > 0) return individual;
  }
  return 0;
};

const sumCommissionAmountsByKind = (commissionList, itemRows) => {
  let profitTotal = 0;
  let fixedTotal = 0;
  (commissionList || []).forEach((c) => {
    const amount = getCommissionLineAmountValue(c, itemRows);
    if (resolveCommissionKind(c) === 'profit') {
      profitTotal += amount;
    } else {
      fixedTotal += amount;
    }
  });
  return {
    profitTotal,
    fixedTotal,
    total: profitTotal + fixedTotal,
  };
};

const applyCommissionToTicketTotal = (itemSubtotal, paymentFee, commissionList, itemRows) => {
  const { profitTotal, fixedTotal } = sumCommissionAmountsByKind(
    commissionList,
    itemRows
  );
  return itemSubtotal + (paymentFee || 0) - profitTotal + fixedTotal;
};

/**
 * Client invoice (Rate / Individual): commission ÷ total qty added to each unit price.
 */
const distributeFixedCommissionIntoCheckoutItems = (items, fixedCommissionAmount) => {
  if (!items || !items.length) return [];
  const commission = parseCommissionNumber(fixedCommissionAmount);
  if (commission <= 0) {
    return items.map((item) => ({ ...item }));
  }

  const totalQty = items.reduce((sum, item) => sum + getCheckoutItemQty(item), 0);
  const perUnitCommission = totalQty > 0 ? commission / totalQty : 0;
  let distributed = 0;

  return items.map((item, idx) => {
    const baseTot = getCheckoutItemTotal(item);
    const basePrice = getCheckoutItemUnitPrice(item);
    const qty = getCheckoutItemQty(item);
    let addAmount;

    if (totalQty <= 0) {
      addAmount =
        idx === items.length - 1
          ? Math.round((commission - distributed) * 100) / 100
          : Math.round((commission / items.length) * 100) / 100;
    } else if (idx === items.length - 1) {
      addAmount = Math.round((commission - distributed) * 100) / 100;
    } else {
      addAmount = Math.round(perUnitCommission * qty * 100) / 100;
    }
    distributed += addAmount;

    const newTotpri = Math.round((baseTot + addAmount) * 100) / 100;
    const newPriperunit =
      qty > 0
        ? Math.round((newTotpri / qty) * 100) / 100
        : Math.round((basePrice + perUnitCommission) * 100) / 100;

    return {
      ...item,
      totpri: newTotpri,
      TotalPrice: newTotpri,
      priperunit: newPriperunit,
      PricePerUnit: newPriperunit,
    };
  });
};

const getCommissionTypeDisplayLabel = (type) => {
  const normalized = normalizeCommissionType(type) || 'Percentage';
  if (normalized === 'Individual') return 'Individual Commission';
  return normalized;
};

const getCommissionPercentValue = (row) =>
  parseCommissionNumber(row.percent ?? row.Percentage ?? row.percentage);

const isNonInventoryItemForCommission = (item, catalog) => {
  const rowItemId = item?.itemid ?? item?.ItemId;
  const rowItemNumber = item?.itemnumber ?? item?.ItemNumber;
  if (rowItemId != null && rowItemId !== '' && rowItemId !== 0) {
    const matchedItem = (catalog || []).find(
      (x) => Number(x?.ItemId) === Number(rowItemId)
    );
    if (matchedItem) {
      const itemFlag = matchedItem.IsNonInventory;
      return (
        itemFlag === true ||
        itemFlag === 1 ||
        String(itemFlag).toLowerCase() === 'true'
      );
    }
  }
  if (rowItemNumber != null && String(rowItemNumber).trim() !== '') {
    const matchedByNum = (catalog || []).find(
      (x) => String(x?.ItemNumber) === String(rowItemNumber)
    );
    if (matchedByNum) {
      const itemFlag = matchedByNum.IsNonInventory;
      return (
        itemFlag === true ||
        itemFlag === 1 ||
        String(itemFlag).toLowerCase() === 'true'
      );
    }
  }
  const v = item?.isNonInventory ?? item?.IsNonInventory ?? item?.isNoninventory;
  return v === true || v === 1 || String(v).toLowerCase() === 'true';
};

const getInvoiceTotalQuantityForCommission = (itemRows, catalog) => {
  if (!itemRows?.length) return 0;
  return itemRows.reduce((sum, item) => {
    if (isNonInventoryItemForCommission(item, catalog)) return sum;
    return sum + getRowCheckoutQuantity(item);
  }, 0);
};

const resolveRowUnitCostForCommission = (item, catalog) => {
  let cost = parseCommissionNumber(item.cost ?? item.Cost);
  if (cost > 0) return cost;
  const itemId = item.itemid ?? item.ItemId;
  const itemNumber = item.itemnumber ?? item.ItemNumber;
  if (catalog?.length) {
    const found = catalog.find(
      (x) =>
        (itemId != null && itemId !== '' && Number(x.ItemId) === Number(itemId)) ||
        (itemNumber != null &&
          String(itemNumber).trim() !== '' &&
          String(x.ItemNumber) === String(itemNumber))
    );
    if (found) {
      cost = parseCommissionNumber(found.Cost);
    }
  }
  return cost;
};

const resolveRowMarginForCommission = (item, catalog) => {
  let margin = parseCommissionNumber(item.margin ?? item.Margin);
  if (margin > 0) return margin;
  const itemId = item.itemid ?? item.ItemId;
  const itemNumber = item.itemnumber ?? item.ItemNumber;
  if (catalog?.length) {
    const found = catalog.find(
      (x) =>
        (itemId != null && itemId !== '' && Number(x.ItemId) === Number(itemId)) ||
        (itemNumber != null &&
          String(itemNumber).trim() !== '' &&
          String(x.ItemNumber) === String(itemNumber))
    );
    if (found) {
      margin = parseCommissionNumber(found.Margin);
    }
  }
  return margin;
};

const getRowLineProfitForCommission = (item, catalog) => {
  const qty = getRowCheckoutQuantity(item);
  const lineTotal = parseCommissionNumber(item.totpri);
  if (lineTotal <= 0) return 0;

  const margin = resolveRowMarginForCommission(item, catalog);
  if (margin > 0 && qty > 0) {
    return qty * margin;
  }

  if (qty <= 0) {
    return lineTotal;
  }

  const unitPrice = parseCommissionNumber(item.priperunit) || lineTotal / qty;
  const unitCost = resolveRowUnitCostForCommission(item, catalog);

  if (unitCost > 0) {
    return Math.max(0, qty * (unitPrice - unitCost));
  }

  return lineTotal;
};

const getItemsProfitForCommission = (rowList, catalog) => {
  if (!rowList?.length) return 0;

  let invoiceTotal = 0;
  let totalCost = 0;
  let marginProfit = 0;
  let lineProfitSum = 0;

  for (const item of rowList) {
    const lineTotal = parseCommissionNumber(item.totpri);
    const qty = getRowCheckoutQuantity(item);
    if (lineTotal <= 0) continue;

    invoiceTotal += lineTotal;
    lineProfitSum += getRowLineProfitForCommission(item, catalog);

    if (qty > 0) {
      totalCost += qty * resolveRowUnitCostForCommission(item, catalog);
      const margin = resolveRowMarginForCommission(item, catalog);
      if (margin > 0) {
        marginProfit += qty * margin;
      }
    }
  }

  // Primary: invoice total minus total cost (qty × unit cost)
  const aggregateProfit = invoiceTotal - totalCost;
  if (aggregateProfit > 0) return aggregateProfit;

  // Fallback: margin-based profit (dynamic-cost items)
  if (marginProfit > 0) return marginProfit;

  // Fallback: per-line profit sum
  if (lineProfitSum > 0) return lineProfitSum;

  // Last resort: use invoice line totals so % commission still calculates
  return invoiceTotal > 0 ? invoiceTotal : 0;
};

const computeCommissionLineAmount = (row, itemRows, catalog) => {
  let type = normalizeCommissionType(row.commissionType ?? row.Type ?? row.type);
  if (!type) {
    type =
      resolveCommissionKind(row) === 'profit'
        ? 'Percentage'
        : (row.rate != null && row.rate !== '') || (row.Rate != null && row.Rate !== '')
          ? 'Rate'
          : 'Individual';
  }
  if (type === 'Percentage') {
    const profit = getItemsProfitForCommission(itemRows, catalog);
    return (profit * getCommissionPercentValue(row)) / 100;
  }
  if (type === 'Rate') {
    const rate = parseCommissionNumber(row.rate ?? row.Rate);
    const totalQty = getInvoiceTotalQuantityForCommission(itemRows, catalog);
    return rate * totalQty;
  }
  if (type === 'Individual') {
    return parseCommissionNumber(row.amount ?? row.Amount);
  }
  return 0;
};

const recalculateCommissionRows = (commissionRowList, itemRows, catalog) => {
  return (commissionRowList || []).map((c) => ({
    ...c,
    commissionAmount:
      Math.round(computeCommissionLineAmount(c, itemRows, catalog) * 100) / 100,
  }));
};

const emptyCommissionRow = (id) => ({
  id,
  commissionId: '',
  commissionName: '',
  commissionType: 'Percentage',
  percent: '',
  rate: '',
  amount: '',
  commissionAmount: 0,
  description: '',
});


function CheckOut(props) { 

	const embeddedInDialog = props.embeddedInDialog === true;
	const location = useLocation();
    const pathname = location.pathname;
	const pageName = pathname.substring(1);
	const [showConfirmTargetPrice, setShowConfirmTargetPrice] = React.useState(false);
	const [belowTargetPriceWarningItems, setBelowTargetPriceWarningItems] = React.useState([]);
	const [pendingBelowTargetSubmit, setPendingBelowTargetSubmit] = React.useState(false);
	const [showConfirmBelowCost, setShowConfirmBelowCost] = React.useState(false);
	const [belowCostWarningItems, setBelowCostWarningItems] = React.useState([]);
	const [pendingSubmitCancelAllReserve, setPendingSubmitCancelAllReserve] = React.useState(false);
	const [pendingBelowCostSubmit, setPendingBelowCostSubmit] = React.useState(false);
    const [apiPaymentMethodData, setApiPaymentMethodData] = useState([]);
	const [apiCommissionData, setApiCommissionData] = useState([]);
	const [commissionRows, setCommissionRows] = useState([]);
	const [commissionTotal, setCommissionTotal] = useState(0);
	const [showCommissionConfirm, setShowCommissionConfirm] = React.useState(false);
	const [commissionRowIndex, setCommissionRowIndex] = React.useState(0);
	const  contentRef = React.createRef();
    const gridRef = React.createRef();
	const invoiceTypeToggleRef = React.createRef();
	
	const [apiVendorData, setApiVenderData] = useState([]);
	const [apiItemData, setApiItemData] = useState([]);
	const [apiLocationData, setApiLocationData] = useState([]);
	const [successMessage, setSuccessMessage] = useState(null);
	const [errorMessage, setErrorMessage] = useState(null);
	const [checkOutQtyMsg, setCheckOutQtyMsg] = useState(null);
	const [showTranDetail, setshowTranDetail] = React.useState(false);
  const [invoiceType, setInvoiceType] = React.useState('internal');
  const [tranDetail, settranDetail] = React.useState([]);
  const [fullWidthTrans] = React.useState(true);
  const [maxWidthTrans] = React.useState('md');
  const [rowIndex, setRowIndex] = React.useState(0);
  const user = JSON.parse(sessionStorage.getItem('user') || '{}');
  const [loading, setloading] = React.useState(false);
  const [tranEdit]  = React.useState(props.tranDetail);
  const [tranAction]  = React.useState(props.action);
  const [userName, setUserName] = React.useState('');
  const [isAdded] = React.useState(false);
const [showCancelConfirm, setShowCancelConfirm] = React.useState(false);
  const [revealedTargetPriceRowKeys, setRevealedTargetPriceRowKeys] = React.useState({});
  const [revealedCostRowKeys, setRevealedCostRowKeys] = React.useState({});

	  const isCostRevealed = (rowKey) => !!revealedCostRowKeys[rowKey];

	  const getCostDisplay = (row, index) => {
	    if (!hasCostValue(row.cost)) return '';
	    const rowKey = getCostRowKey(row, index);
	    if (isCostRevealed(rowKey)) {
	      return formatCostDisplay(row.cost);
	    }
	    return maskCostDisplay(row.cost);
	  };

	  const toggleCostVisibility = (rowKey) => {
	    if (!rowKey) return;
	    setRevealedCostRowKeys((prev) => {
	      if (!prev[rowKey]) return { ...prev, [rowKey]: true };
	      const next = { ...prev };
	      delete next[rowKey];
	      return next;
	    });
	  };

	  const hideCost = (rowKey) => {
	    setRevealedCostRowKeys((prev) => {
	      if (!prev[rowKey]) return prev;
	      const next = { ...prev };
	      delete next[rowKey];
	      return next;
	    });
	  };

	  const resetCostReveal = (rowKey) => {
	    hideCost(rowKey);
	  };

  const isTargetPriceRevealed = (rowKey) => !!revealedTargetPriceRowKeys[rowKey];

  const getTargetPriceDisplay = (row, index) => {
    if (!hasTargetPriceValue(row.targetprice)) return '';
    const rowKey = getTargetPriceRowKey(row, index);
    if (isTargetPriceRevealed(rowKey)) {
      return formatTargetPriceDisplay(row.targetprice);
    }
    return maskTargetPriceDisplay(row.targetprice);
  };

  const toggleTargetPriceVisibility = (rowKey) => {
    if (!rowKey) return;
    setRevealedTargetPriceRowKeys((prev) => {
      if (!prev[rowKey]) return { ...prev, [rowKey]: true };
      const next = { ...prev };
      delete next[rowKey];
      return next;
    });
  };

  const hideTargetPrice = (rowKey) => {
    setRevealedTargetPriceRowKeys((prev) => {
      if (!prev[rowKey]) return prev;
      const next = { ...prev };
      delete next[rowKey];
      return next;
    });
  };

  const resetTargetPriceReveal = (rowKey) => {
    hideTargetPrice(rowKey);
  };

  const generatePdf = () => {
	exportInvoicePdf({
	  element: contentRef.current,
	  gridElement: gridRef.current,
	  hiddenElements: [invoiceTypeToggleRef.current],
	});

  };


  const handleTargetPriceUpdate = (type) => {
	setShowConfirmTargetPrice(false);
	setBelowTargetPriceWarningItems([]);
	if (type === 'Yes' && pendingBelowTargetSubmit) {
	  submit(pendingSubmitCancelAllReserve, true, true);
	}
	setPendingBelowTargetSubmit(false);
  };

  const parseUnitAmount = (value) => {
	const n = parseFloat(value);
	return Number.isFinite(n) ? n : null;
  };

  const isCheckoutSale = () =>
	formData.action === 'CheckOut' ||
	tranAction === 'return-order' ||
	(tranEdit != null && String(formData.ticketNumber || '').includes('OUT'));

	const isReserveCreateOrderContext = () =>
	formData.action === 'Reserve' && tranAction === 'return-order';

	  const isCostDisplayContext = () =>
		formData.action === 'CheckOut' || formData.action === 'Reserve';

  const rowHasSelectedItemForCostCheck = (row) => {
	const id = row?.itemid ?? row?.ItemId;
	return id != null && id !== '' && Number(id) > 0;
  };

  const resolveRowUnitCost = (row) => {
	const directCost = parseUnitAmount(row.cost ?? row.Cost);
	if (directCost != null && directCost > 0) {
	  return directCost;
	}
	const itemId = row.itemid ?? row.ItemId;
	if (itemId != null && itemId !== '') {
	  const fromCatalog = apiItemData.find(
		(item) => Number(item.ItemId) === Number(itemId)
	  );
	  if (fromCatalog) {
		const catalogCost = parseUnitAmount(fromCatalog.Cost);
		if (catalogCost != null && catalogCost > 0) {
		  return catalogCost;
		}
	  }
	}
	return directCost != null ? directCost : 0;
  };

  const getBelowCostCheckoutRows = (rowList) => {
	const source = rowList != null ? rowList : rows;
	return source
	  .map((row, index) => ({ row, index }))
	  .filter(({ row }) => rowHasSelectedItemForCostCheck(row))
	  .map(({ row, index }) => {
		const unitPrice = parseUnitAmount(row.priperunit);
		const cost = resolveRowUnitCost(row);
		return { row, index, unitPrice, cost };
	  })
	  .filter(
		({ unitPrice, cost }) =>
			unitPrice != null && cost != null && cost > 0 && unitPrice + 1e-6 < cost
	  )
	  .map(({ row, index, unitPrice, cost }) => ({
		index,
		itemnumber: row.itemnumber || row.ItemNumber || '',
		itemname: row.itemname || row.ItemName || '',
		unitPrice,
		cost,
	  }));
  };

  const getBelowTargetPriceCheckoutRows = (rowList) => {
	const source = rowList != null ? rowList : rows;
	return source
	  .map((row, index) => ({ row, index }))
	  .filter(({ row }) => rowHasSelectedItemForCostCheck(row))
	  .map(({ row, index }) => {
		const unitPrice = parseUnitAmount(row.priperunit);
		const targetPrice = parseUnitAmount(row.targetprice);
		return { row, index, unitPrice, targetPrice };
	  })
	  .filter(
		({ row, unitPrice, targetPrice }) =>
		  hasTargetPriceValue(row.targetprice) &&
		  unitPrice != null &&
		  targetPrice != null &&
		  unitPrice + 1e-6 < targetPrice
	  )
	  .map(({ row, index, unitPrice, targetPrice }) => ({
		index,
		itemnumber: row.itemnumber || row.ItemNumber || '',
		itemname: row.itemname || row.ItemName || '',
		unitPrice,
		targetPrice,
	  }));
  };

  const handleBelowCostConfirm = (proceed) => {
	setShowConfirmBelowCost(false);
	setBelowCostWarningItems([]);
	if (proceed && pendingBelowCostSubmit) {
	  // Cost confirmed; still run below-target check before completing submit
	  submit(pendingSubmitCancelAllReserve, true, false);
	}
	setPendingBelowCostSubmit(false);
  };

const handleCloseConfirm= () => { 
		setShowCancelConfirm(false); 
   
	}; 

  const handleCancelConfirm = () => { 
		setShowCancelConfirm(true); 
   
	}; 


const handleCancelReserveOrder = () => {
	handleCloseConfirm();
	handleSubmit(true);
};

  const refreshCheckoutItemCatalog = React.useCallback(() => {
	let accessToken = getAccessToken();
	try {
	  const sessionUser = JSON.parse(sessionStorage.getItem('user'));
	  accessToken = sessionUser?.accessToken || '';
	} catch (e) {
	  // Continue unauthenticated when stored session data is malformed.
	}
	return apiClient
	  .get(`/api/get/item`, checkoutItemCatalogRequestConfig(accessToken))
	  .then((res) => {
		setApiItemData(filterCheckoutAutocompleteItems(res.data || []));
	  });
  }, []);

	useEffect(() => {
		refreshCheckoutItemCatalog();
		const onVisible = () => {
			if (document.visibilityState === 'visible') {
				refreshCheckoutItemCatalog();
			}
		};
		window.addEventListener('focus', refreshCheckoutItemCatalog);
		document.addEventListener('visibilitychange', onVisible);
		return () => {
			window.removeEventListener('focus', refreshCheckoutItemCatalog);
			document.removeEventListener('visibilitychange', onVisible);
		};
	}, [location.key, refreshCheckoutItemCatalog]);

  const closeTransDetailDialog = () =>{
	setshowTranDetail(false);
	setInvoiceType('internal');
	setformData({
		date: new Date(),
		// Keep the Invoice page in CheckOut mode; an empty action hides the
		// Broker and Payment Method fields until the user leaves the page.
		action: pageName === 'CheckOut' && tranEdit == null ? 'CheckOut' : '',
		customerId: null,
		broker1CustomerId: '',
		broker2CustomerId: '',
		broker3CustomerId: '',
		paymentMethodId: 1,
		ponumber: '',
});

formData.ponumber = '';

setRows([]);
setCommissionRows([]);
setCommissionTotal(0);
setGrandTotal(0);
setInvoiceSubtotal(0);
setTotalQty(0);
refreshCheckoutItemCatalog();

	// When embedded (e.g. Create Order from Reserves), parent refresh was deferred
	// so this detail dialog could stay mounted — notify parent now that it closed.
	if (embeddedInDialog && typeof props.onSendValue === 'function') {
		props.onSendValue();
	}
};



	useEffect(() => {
		if (pageName === 'CheckOut' && tranEdit == null) {
			setformData((prev) => {
				if (prev.action) {
					return prev;
				}
				return { ...prev, action: 'CheckOut' };
			});
		}
	}, [pageName, tranEdit]);

	useEffect(() => {
	  const fetchData = async () => {
		try {
		  sessionStorage.setItem('TranSearch', null);
		  sessionStorage.setItem('ItemTabIndex', JSON.stringify(0));
		  let user = JSON.parse(sessionStorage.getItem('user'));
		  setUserName(user.userName);
		  let accessToken = getAccessToken();

		  apiClient.get(`/api/get/customer`, { headers: {"Authorization" : `Bearer ${accessToken}`} })
		  .then(res => {
			const vendorList = res.data;
			
			setApiVenderData(vendorList);
		  });

		   apiClient.get(`/api/get/paymentMethod`, { headers: {"Authorization" : `Bearer ${accessToken}`} })
				  .then(res => {
					const paymentMethodList = res.data;
					setApiPaymentMethodData(paymentMethodList);
				  });

		  apiClient.get(`/api/get/commission`, { headers: { Authorization: `Bearer ${accessToken}` } })
			.then((res) => setApiCommissionData(res.data || []));

		  apiClient.get(`/api/get/itemlocation`, { headers: { Authorization: `Bearer ${accessToken}` } })
			.then((res) => setApiLocationData(res.data || []));

		   if(user.permissions.filter(x=>x.PermissionName == 'Check Out Product' && x.PermissionAllowed == 1).length == 0)
         {
            const { history } = this.props;
            history.push('/home');
         }

		  apiClient.get(`/api/get/item`, checkoutItemCatalogRequestConfig(accessToken))
		  .then(res => {
			const itemList = filterCheckoutAutocompleteItems(res.data || []);
			setApiItemData(itemList);
			if(tranEdit != null)
			{
				var items = [];
				var olditems = [];
				var total = 0;
				var totalQty = 0;
				var formData = {
					date: null,
					action:'',
					vendorId: 0,
					customerId:0,
					broker1CustomerId:'',
					broker2CustomerId:'',
					broker3CustomerId:'',
					ponumber:'',
					ticketNumber: '',
					reason:'',
					user:''
			};
			if(tranEdit.TicketNumber.includes('OUT'))
			{
                formData.action = 'CheckOut';
			}
			else if(tranEdit.TicketNumber.includes('CHK'))
			{
				formData.action = 'CheckIn';
			}
			else if(tranEdit.TicketNumber.includes('RET'))
			{
				formData.action = 'Return';
			}
			else if(tranEdit.TicketNumber.includes('RES'))
			{
				formData.action = 'Reserve';
			}
			else if(tranEdit.TicketNumber.includes('ADJ'))
			{
				formData.action = 'Adjustment';
			}
				tranEdit.items.forEach(function(item){
					var itemDetail = itemList.filter(x=>x.ItemNumber == item.ItemNumber)[0];
					const baseRow = buildCheckoutRowFromTransactionItem(
						item,
						itemDetail,
						formData.action,
						rows.length + 1
					);
					formData.date = moment(item.Date);
					formData.vendorId = item.VendorId;
					formData.customerId = item.CustomerId;
					formData.ponumber = item.PONumber;
					formData.reason = item.Reason;
					formData.ticketNumber = item.TicketNumber;
					formData.customerName = item.CustomerName;
					formData.broker1CustomerId = item.Broker1CustomerId || '';
					formData.broker2CustomerId = item.Broker2CustomerId || '';
					formData.broker3CustomerId = item.Broker3CustomerId || '';
					formData.broker1Name = item.Broker1Name || '';
					formData.broker2Name = item.Broker2Name || '';
					formData.broker3Name = item.Broker3Name || '';
					formData.returnTicketNumber = item.ReturnTicketNumber;
					formData.user = item.UserName;
					formData.targetPrice = item.TargetPrice;
					formData.paymentMethodId = item.PaymentMethodId??1;
					formData.paymentFee = item.PaymentFee??0;
					
					items.push(baseRow);
					total += item.TotalPrice;
					if (!(itemDetail && (itemDetail.IsNonInventory === 1 || itemDetail.IsNonInventory === true))) {
						totalQty += parseFloat(item.Quantity ?? 0);
					}
					olditems.push(JSON.parse(JSON.stringify(baseRow)));
				});

				 
				setformData(formData);
				setOldRows(olditems);
				setRows(items);
				items.forEach((it, idx) => {
					if (it && it.itemid) {
						fetchLocationStockForRow(it.itemid, idx, olditems[idx]);
					}
				});
				setEdit(true); 
				setGrandTotal(total);
				setInvoiceSubtotal(total);
				setTotalQty(totalQty);

				const applyEditCheckoutTotals = (itemRows, paymentMethodId, paymentMethodList, commissionList) => {
					const paymentPer =
						(paymentMethodList || []).filter((x) => x.PaymentMethodId == paymentMethodId)[0]
							?.Percent ?? 0;
					let total = 0;
					let totalQty = 0;
					let paymentFee = 0;
					itemRows.forEach((item) => {
						total += item.totpri;
						if (!isNonInventoryRow(item)) {
							totalQty += parseFloat(item.checkoutqty ?? 0);
						}
						const paymentPerAmount = (item.totpri * paymentPer) / 100;
						item.paymentFee = paymentPerAmount;
						paymentFee += item.paymentFee ?? 0;
					});
					const recalced = recalculateCommissionRows(commissionList || [], itemRows, itemList);
					const { total: commTotal } = sumCommissionAmountsByKind(recalced, itemRows);
					setCommissionRows(recalced);
					setCommissionTotal(commTotal);
					setInvoiceSubtotal(total);
					setGrandTotal(applyCommissionToTicketTotal(total, paymentFee, recalced, itemRows));
					setTotalQty(totalQty);
					setPaymentFee(paymentFee);
				};

				if (formData.action === 'CheckOut' && formData.ticketNumber) {
					Promise.all([
						apiClient.get(`/api/get/invoicecommission`, {
							params: { ticketnumber: formData.ticketNumber },
							headers: { Authorization: `Bearer ${accessToken}` },
						}),
						apiClient.get(`/api/get/paymentMethod`, {
							headers: { Authorization: `Bearer ${accessToken}` },
						}),
					]).then(([commRes, payRes]) => {
						const loaded = (commRes.data || []).map((c, idx) => {
							let commissionType = normalizeCommissionType(c.Type);
							if (!commissionType) {
								if (c.Rate != null && c.Rate !== '') commissionType = 'Rate';
								else if (c.Amount != null && c.Amount !== '')
									commissionType = 'Individual';
								else if (c.Percentage != null && c.Percentage !== '')
									commissionType = 'Percentage';
								else commissionType = 'Individual';
							}
							return {
								id: idx + 1,
								commissionId: c.CommissionId,
								commissionName: c.CommissionName || '',
								commissionType,
								percent: c.Percentage != null ? c.Percentage : '',
								rate: c.Rate != null ? c.Rate : '',
								amount: c.Amount != null ? c.Amount : '',
								commissionAmount:
									c.CommissionAmount != null ? c.CommissionAmount : 0,
								description: c.Description != null ? c.Description : '',
							};
						});
						applyEditCheckoutTotals(
							items,
							formData.paymentMethodId,
							payRes.data,
							loaded
						);
					});
				} else {
					apiClient
						.get(`/api/get/paymentMethod`, {
							headers: { Authorization: `Bearer ${accessToken}` },
						})
						.then((payRes) => {
							applyEditCheckoutTotals(items, formData.paymentMethodId, payRes.data, []);
						});
				}

				
				
			}
			
		  });
  
		  
		} catch (error) {
		  console.error('Error fetching data:', error);
		}
	  };
  
	  fetchData();
	}, []); // Empty dependency array ensures that useEffect runs only once when the component is mounted
  
	const classes = useStyles();
	const tableCellClass = embeddedInDialog ? classes.tableCellEmbedded : classes.tableCell;
	const tableClassName = embeddedInDialog
		? `${classes.table} ${classes.tableEmbedded}`
		: classes.table; 

	const [formData, setformData] = useState({
            date: new Date(),
			action: '',
            customerId: null,
			broker1CustomerId: '',
			broker2CustomerId: '',
			broker3CustomerId: '',
			ponumber: '',
			reason: '',
			user:'',
			paymentMethodId: 1,
    });

	const [rows, setRows] = useState([]);

	const [oldRows, setOldRows] = useState([]);

	const [open, setOpen] = React.useState(false); 
	const [grandTotal, setGrandTotal] = React.useState(0); 
	const [totalQty, setTotalQty] = React.useState(0); 
	const [paymentFee, setPaymentFee] = React.useState(0);
	const [invoiceSubtotal, setInvoiceSubtotal] = React.useState(0); 
	const [isEdit, setEdit] = React.useState(false); 
	const [, setDisable] = React.useState(true);
	const [showConfirm, setShowConfirm] = React.useState(false); 

	

	const handleClose = (event, reason) => { 
		if (reason === "clickaway") { 
			return; 
		} 
		setOpen(false); 
	}; 

	const handleDateChange = (value) => { 
		
		formData['date'] = value;
		setformData({
			date: formData.date,
			action: formData.action,
			customerId: formData.customerId,
			customerName: formData.customerName,
			broker1CustomerId: formData.broker1CustomerId,
			broker2CustomerId: formData.broker2CustomerId,
			broker3CustomerId: formData.broker3CustomerId,
			ponumber: formData.ponumber,
			ticketNumber:formData.ticketNumber,
			paymentMethodId: formData.paymentMethodId,
			reason: formData.reason,
			user:formData.user,
	});
	}; 

	const handleAdd = () => { 

		if(checkOutQtyMsg != null)
		{
			setTimeout(() => {
				setErrorMessage(checkOutQtyMsg);
			}, 1000);

			setTimeout(() => {
				setErrorMessage(null); 
			   
  
		  }, 5000);

		}
		else{
			setRows([ 
				...rows, 
				{ 
					id: rows.length + 1,  
					itemid: '', itemname:'',qtyinstock: 0,cost:'',targetprice:'',checkoutqty:0 ,priperunit:0,totpri:0,itemnumber:'',
					isNonInventory: false, selectedLocationIds: [], locationOptions: [], locationAllocations: []
	
				}, 
			]); 
			setEdit(true); 

		}

		
	};
	
	const handleAddBarcode = () => { 

		
		setSuccessMessage('Barcode reader is not configure');
		

		setTimeout(() => {
		  setSuccessMessage(null); 
		}, 2000);
		
	}; 
	const getTransactionType = (TicketNumber) =>{

		if(TicketNumber != undefined)
		{
			if(TicketNumber.includes('OUT'))
			{
				return 'Invoice';
			}
			else if(TicketNumber.includes('CHK'))
			{
				return  'Purchase Order';
			}
			else if(TicketNumber.includes('RET'))
			{
				return  'Product Return';
			}
			else if(TicketNumber.includes('RES'))
			{
				return 'Product Reserves';
			}
			else if(TicketNumber.includes('ADJ'))
			{
				return 'Product Adjustments';
			}
		}
		
	  
	  };

	const calculateTotals = (rowList, commissionList) => {
        var  paymentPer =apiPaymentMethodData.filter(x=>x.PaymentMethodId == formData.paymentMethodId)[0]?.Percent??0;
		const source = rowList != null ? rowList : rows;
		var total = 0;
				var totalQty = 0;
				var paymentFee = 0;
				source.forEach(function(item){
					total += item.totpri;
					if (!isNonInventoryRow(item)) {
						totalQty += parseFloat(item.checkoutqty ?? 0);
					}
			       var  paymentPerAmount = (item.totpri * paymentPer) / 100;
				   item.paymentFee = paymentPerAmount;
				    item.paymentMethodId = formData.paymentMethodId;
					paymentFee += item.paymentFee??0;
				});
				const commSource = commissionList != null ? commissionList : commissionRows;
				const updatedCommissions = recalculateCommissionRows(commSource, source, apiItemData);
				const { total: commTotal } = sumCommissionAmountsByKind(updatedCommissions, source);
				setCommissionRows(updatedCommissions);
				setCommissionTotal(commTotal);
				setInvoiceSubtotal(total);
				setGrandTotal(applyCommissionToTicketTotal(total, paymentFee, updatedCommissions, source));
				setTotalQty(totalQty);
				setPaymentFee(paymentFee);
				return { updatedCommissions, commTotal };
	};

	const isCheckoutCommissionForm = () =>
		formData.action === 'CheckOut' &&
		tranAction !== 'return' &&
		tranAction !== 'return-order';

	const handleAddCommission = () => {
		if (commissionRows.length > 0) {
			const last = commissionRows[commissionRows.length - 1];
			if (!last.commissionId) {
				setErrorMessage('Select a commission for the last row before adding another.');
				setTimeout(() => setErrorMessage(null), 5000);
				return;
			}
		}
		const next = [...commissionRows, emptyCommissionRow(commissionRows.length + 1)];
		calculateTotals(rows, next);
	};

	const handleCommissionSelect = (e, index) => {
		const commissionId = e.target.value;
		const selected = apiCommissionData.find(
			(c) => String(c.CommissionId) === String(commissionId)
		);
		const list = [...commissionRows];
		if (!selected) {
			list[index] = { ...list[index], commissionId: '', commissionName: '', commissionAmount: 0 };
		} else {
			const commissionType =
				normalizeCommissionType(selected.Type || 'Percentage') || 'Percentage';
			list[index] = {
				...list[index],
				commissionId: selected.CommissionId,
				commissionName: selected.Name || '',
				commissionType,
				percent:
					commissionType === 'Percentage'
						? (selected.Percentage != null && selected.Percentage !== ''
							? selected.Percentage
							: selected.percentage != null && selected.percentage !== ''
								? selected.percentage
								: list[index].percent ?? '')
						: '',
				rate:
					commissionType === 'Rate'
						? (selected.Rate != null && selected.Rate !== ''
							? selected.Rate
							: selected.rate ?? '')
						: '',
				amount:
					commissionType === 'Individual'
						? (selected.Amount != null && selected.Amount !== ''
							? selected.Amount
							: selected.amount != null && selected.amount !== ''
								? selected.amount
								: list[index].amount ?? '')
						: '',
			};
		}
		calculateTotals(rows, list);
	};

	const handleCommissionValueChange = (e, index) => {
		const { name, value } = e.target;
		const list = [...commissionRows];
		list[index][name] = value;
		calculateTotals(rows, list);
	};

	const handleCommissionDescriptionChange = (e, index) => {
		const list = [...commissionRows];
		list[index].description = e.target.value;
		setCommissionRows(list);
	};

	const handleCommissionConfirm = (id) => {
		setShowCommissionConfirm(true);
		setCommissionRowIndex(id);
	};

	const handleCommissionRemove = () => {
		const list = commissionRows.filter((x) => x.id !== commissionRowIndex);
		setShowCommissionConfirm(false);
		calculateTotals(rows, list);
	};

	const handleCommissionConfirmNo = () => setShowCommissionConfirm(false);

	const getCommissionValueFieldMeta = (commissionType) => {
		const type = normalizeCommissionType(commissionType) || 'Percentage';
		if (type === 'Percentage') {
			return { name: 'percent', label: 'Percent of profit %', enabled: true };
		}
		if (type === 'Rate') {
			return { name: 'rate', label: 'Rate (× total qty)', enabled: true };
		}
		if (type === 'Individual') {
			return { name: 'amount', label: 'Individual amount', enabled: true };
		}
		return { name: 'percent', label: 'Percent of profit %', enabled: false };
	};

	const checkoutStockMsg = 'Selected item has no stock or not enough stock. Please change the item or adjust the checkout quantity.';

	const sameGridItem = (a, b) => {
		if (!a || !b) return false;
		if (a.itemid && b.itemid && String(a.itemid) === String(b.itemid)) return true;
		const an = a.itemnumber != null ? String(a.itemnumber) : '';
		const bn = b.itemnumber != null ? String(b.itemnumber) : '';
		return an !== '' && an === bn;
	};

	const pickLookupItemFromResponse = (data, preferItemId) => {
		const arr = Array.isArray(data) ? data : [];
		if (!arr.length) return undefined;
		if (preferItemId != null && String(preferItemId).trim() !== '') {
			const byId = arr.find((x) => String(x.ItemId) === String(preferItemId));
			if (byId) return byId;
		}
		return arr[0];
	};

	const getItemCategoryName = (item) => {
		if (item?.categoryName) return item.categoryName;
		if (item?.CategoryName) return item.CategoryName;
		const itemId = item?.itemid ?? item?.ItemId;
		const itemNumber = item?.itemnumber ?? item?.ItemNumber;
		if (itemId != null && itemId !== '' && itemId !== 0) {
			const matchedItem = apiItemData.find(
				(apiItem) => Number(apiItem?.ItemId) === Number(itemId)
			);
			if (matchedItem?.CategoryName) return matchedItem.CategoryName;
		}
		if (itemNumber != null && String(itemNumber).trim() !== '') {
			const matchedByNum = apiItemData.find(
				(apiItem) => String(apiItem?.ItemNumber) === String(itemNumber)
			);
			if (matchedByNum?.CategoryName) return matchedByNum.CategoryName;
		}
		return '';
	};

	const getItemEntityGroupName = (item) => {
		if (item?.EntityGroupName) return item.EntityGroupName;
		if (item?.entityGroupName) return item.entityGroupName;
		const itemId = item?.itemid ?? item?.ItemId;
		const itemNumber = item?.itemnumber ?? item?.ItemNumber;
		if (itemId != null && itemId !== '' && itemId !== 0) {
			const matchedItem = apiItemData.find(
				(apiItem) => Number(apiItem?.ItemId) === Number(itemId)
			);
			if (matchedItem?.EntityGroupName) return matchedItem.EntityGroupName;
		}
		if (itemNumber != null && String(itemNumber).trim() !== '') {
			const matchedByNum = apiItemData.find(
				(apiItem) => String(apiItem?.ItemNumber) === String(itemNumber)
			);
			if (matchedByNum?.EntityGroupName) return matchedByNum.EntityGroupName;
		}
		return '';
	};

	const isCommissionCategoryItem = (item) => {
		const categoryName = String(getItemCategoryName(item) || '').trim().toLowerCase();
		return categoryName === 'commission' || categoryName === 'commision';
	};

		const isCheckoutInvoiceTicket = () =>
			formData.action === 'CheckOut' ||
			(tranDetail?.TicketNumber && String(tranDetail.TicketNumber).includes('OUT'));

		const showInternalInvoiceAccounting = () =>
			isCheckoutInvoiceTicket() && invoiceType === 'internal';

	const getTranDetailDisplayItems = () => {
		const items = tranDetail?.items || [];
		if (!isCheckoutInvoiceTicket() || invoiceType !== 'client') {
			return items;
		}
		// Client invoice: hide commission lines; bake Rate/Individual into unit prices.
		const invoiceItems = items.filter((item) => !isCommissionCategoryItem(item));
		const commissions = tranDetail?.commissions || [];
		let { fixedTotal, profitTotal } = sumCommissionAmountsByKind(
			commissions,
			invoiceItems
		);
		if (fixedTotal <= 0 && profitTotal <= 0) {
			const rawTotal = parseFloat(tranDetail?.TotalCommission) || 0;
			if (rawTotal > 0) fixedTotal = rawTotal;
		}
		return distributeFixedCommissionIntoCheckoutItems(invoiceItems, fixedTotal);
	};

	const getTranDetailDisplayTotals = () => {
		const sourceItems = (tranDetail?.items || []).filter(
			(item) => !isCommissionCategoryItem(item)
		);
		const originalSubtotal = sourceItems.reduce(
			(sum, item) => sum + getCheckoutItemTotal(item),
			0
		);
		const totalPaymentFee = parseFloat(tranDetail?.TotalPaymentFee) || 0;
		const commissions = tranDetail?.commissions || [];
		let { total: totalCommission, fixedTotal, profitTotal } =
			sumCommissionAmountsByKind(commissions, sourceItems);
		if (fixedTotal <= 0 && profitTotal <= 0) {
			const rawTotal = parseFloat(tranDetail?.TotalCommission) || 0;
			if (rawTotal > 0) {
				fixedTotal = rawTotal;
				totalCommission = rawTotal;
			}
		}

		// Rate/Individual: Internal and Client grand totals both use
		// originalSubtotal + paymentFee + fixedTotal (profit omitted on client).
		const sharedGrandTotal =
			originalSubtotal + totalPaymentFee - (invoiceType === 'client' ? 0 : profitTotal) + fixedTotal;

		if (isCheckoutInvoiceTicket() && invoiceType === 'client') {
			const displayItems = getTranDetailDisplayItems();
			const displaySubtotal = displayItems.reduce(
				(sum, item) => sum + getCheckoutItemTotal(item),
				0
			);
			return {
				itemSubtotal: displaySubtotal,
				totalCommission: 0,
				totalTicketPrice: sharedGrandTotal,
				totalPaymentFee,
				fixedCommissionTotal: fixedTotal,
			};
		}

		return {
			itemSubtotal: originalSubtotal,
			totalCommission:
				totalCommission || parseFloat(tranDetail?.TotalCommission) || 0,
			totalTicketPrice: sharedGrandTotal,
			totalPaymentFee,
			fixedCommissionTotal: fixedTotal,
		};
	};

	const isNonInventoryRow = (row) => {
		const rowItemId = row?.itemid ?? row?.ItemId;
		const rowItemNumber = row?.itemnumber ?? row?.ItemNumber;
		if (rowItemId != null && rowItemId !== '' && rowItemId !== 0) {
			const matchedItem = apiItemData.find(
				(item) => Number(item?.ItemId) === Number(rowItemId)
			);
			if (matchedItem) {
				const itemFlag = matchedItem.IsNonInventory;
				return (
					itemFlag === true ||
					itemFlag === 1 ||
					String(itemFlag).toLowerCase() === 'true'
				);
			}
		}
		if (rowItemNumber != null && String(rowItemNumber).trim() !== '') {
			const matchedByNum = apiItemData.find(
				(item) => String(item?.ItemNumber) === String(rowItemNumber)
			);
			if (matchedByNum) {
				const itemFlag = matchedByNum.IsNonInventory;
				return (
					itemFlag === true ||
					itemFlag === 1 ||
					String(itemFlag).toLowerCase() === 'true'
				);
			}
		}
		const v = row?.isNonInventory ?? row?.IsNonInventory ?? row?.isNoninventory;
		return v === true || v === 1 || String(v).toLowerCase() === 'true';
	};

	const getTotalQuantity = () => {
		let t = 0;
		getTranDetailDisplayItems().forEach((element) => {
			if (!isNonInventoryRow(element)) {
				t += parseFloat(element.checkoutqty ?? 0);
			}
		});
		return parseFloat(t)?.toFixed(2);
	};

	const getTotalQuantityEditMode = () => {
		let t = 0;
		if (rows != null && rows.length > 0) {
			rows.forEach((r) => {
				if (!isNonInventoryRow(r)) {
					t += parseFloat(r.checkoutqty ?? 0);
				}
			});
		}
		return parseFloat(t)?.toFixed(2);
	};

	const isReturnTransaction = () =>
		(tranAction != null && tranAction !== undefined && String(tranAction).indexOf('return') !== -1) ||
		formData.action === 'Return';

	const usesSingleResolvedLocation = () =>
		isReturnTransaction() || formData.action === 'Adjustment';

	const isEditStockTransaction = () =>
		tranAction != null && tranAction !== undefined && String(tranAction) !== '' && !isReturnTransaction();

	const shouldValidateCheckoutStock = () =>
		(formData.action === 'CheckOut' || formData.action === 'Reserve') &&
		!isReturnTransaction();

	const shouldValidateAdjustmentStock = () =>
		formData.action === 'Adjustment' && !isReturnTransaction();

	const shouldRequireLocationSelection = (row) => {
		if (isReturnTransaction() || formData.action === 'Adjustment') return false;
		if (row && isNonInventoryRow(row)) return false;
		return formData.action === 'CheckOut' || formData.action === 'Reserve';
	};

	const flashCheckoutLocationMessage = (message) => {
		setCheckOutQtyMsg(message);
		setErrorMessage(message);
		setTimeout(() => setErrorMessage(null), 5000);
	};

	const toFixedQty = (v) => Number(parseFloat(v) || 0).toFixed(2);

	const buildLocationAllocations = (selectedIds, options, neededQtyRaw, oldRow = null) => {
		const neededQty = parseFloat(neededQtyRaw) || 0;
		let remaining = neededQty;
		const allocations = [];
		(selectedIds || []).forEach((idRaw) => {
			const id = Number(idRaw);
			const opt = (options || []).find((x) => Number(x.LocationId) === id);
			if (!opt) return;
			const available = oldRow
				? getCheckoutEditLocationEffectiveAvailable(opt.Quantity, oldRow, id)
				: parseFloat(opt.Quantity) || 0;
			if (available <= 0) return;
			const used = remaining > 0 ? Math.min(available, remaining) : 0;
			allocations.push({
				locationId: id,
				locationName: opt.LocationName || '',
				quantity: used,
				availableQuantity: available,
			});
			remaining = Math.max(0, remaining - used);
		});
		return allocations;
	};

	const getRowEditLocationCredit = (rowIndex, locationId) => {
		if (!isCheckoutEditContext(tranAction, formData.action)) return 0;
		return getCheckoutOldQtyAtLocation(oldRows[rowIndex], locationId);
	};

	const getEffectiveLocationAvailable = (row, rowIndex, locationId) => {
		const opt = (row.locationOptions || []).find(
			(o) => Number(o.LocationId) === Number(locationId)
		);
		const apiQty = opt ? parseFloat(opt.Quantity) || 0 : 0;
		if (!isCheckoutEditContext(tranAction, formData.action)) return apiQty;
		return getCheckoutEditLocationEffectiveAvailable(
			apiQty,
			oldRows[rowIndex],
			locationId
		);
	};

	const locationOptionHasSelectableStock = (loc, rowIndex) => {
		if (checkoutLocationHasStock(loc)) return true;
		if (!isCheckoutEditContext(tranAction, formData.action)) return false;
		return getRowEditLocationCredit(rowIndex, loc.LocationId) > 0;
	};

	const selectedLocationTotalAvailable = (row, rowIndex) => {
		if (isCheckoutEditContext(tranAction, formData.action)) {
			return (row.selectedLocationIds || []).reduce(
				(s, id) => s + getEffectiveLocationAvailable(row, rowIndex, id),
				0
			);
		}
		return (row.locationAllocations || []).reduce(
			(s, a) => s + (parseFloat(a.availableQuantity) || 0),
			0
		);
	};

	const selectedLocationTotalAssigned = (row) =>
		(row.locationAllocations || []).reduce(
			(s, a) => s + (parseFloat(a.quantity) || 0),
			0
		);

	const validateLocationForRow = (row, rowIndex, options = {}) => {
		if (!shouldRequireLocationSelection(row)) return null;
		const reqQty = parseFloat(row.checkoutqty) || 0;
		if (reqQty <= 0) return null;
		if (!row.itemid && !row.itemnumber) return null;

		const opts = row.locationOptions || [];
		const selected = row.selectedLocationIds || [];

		if (!opts.length) {
			return `Row ${rowIndex + 1}: No locations are configured for this item.`;
		}

		const hasStockSomewhere = opts.some((opt) =>
			locationOptionHasSelectableStock(opt, rowIndex)
		);
		if (!hasStockSomewhere) {
			return `Row ${rowIndex + 1}: All locations have no available quantity.`;
		}

		if (!selected.length) {
			// While typing, the Location column comes after Qty; only Submit asks for it.
			if (options.whileTyping) return null;
			return `Row ${rowIndex + 1}: Please select a location.`;
		}

		for (let s = 0; s < selected.length; s += 1) {
			const opt = opts.find((o) => Number(o.LocationId) === Number(selected[s]));
			if (opt && !locationOptionHasSelectableStock(opt, rowIndex)) {
				return `Row ${rowIndex + 1}: ${checkoutLocationNoQtyMsg}`;
			}
		}

		const totalAvailable = selectedLocationTotalAvailable(row, rowIndex);

		if (isCheckoutEditContext(tranAction, formData.action)) {
			if (reqQty > totalAvailable + 1e-6) {
				return `Row ${rowIndex + 1}: Selected location quantity is not enough for requested Qty (${toFixedQty(reqQty)}). Maximum available at this location: ${toFixedQty(totalAvailable)}.`;
			}
			return null;
		}

		const totalAssigned = selectedLocationTotalAssigned(row);
		if (totalAvailable + 1e-6 < reqQty || totalAssigned + 1e-6 < reqQty) {
			return `Row ${rowIndex + 1}: Selected location quantity is not enough for requested Qty (${toFixedQty(reqQty)}).`;
		}
		return null;
	};

	const fetchLocationStockForRow = (itemId, rowIndex, editOldRowSnapshot) => {
		if (!itemId || Number(itemId) <= 0) return;
		let accessToken = getAccessToken();
		apiClient
			.get(`/api/get/itemlocationstock`, {
				params: { itemId },
				headers: { Authorization: `Bearer ${accessToken}` },
			})
			.then((res) => {
				let opts = (res.data || []).map((x) => ({
					LocationId: Number(x.LocationId),
					LocationName: x.LocationName,
					Quantity: parseFloat(x.Quantity) || 0,
				}));
				if (opts.length === 0) {
					const defId = getDefaultLocationIdFromList(apiLocationData);
					if (defId !== '' && defId != null) {
						const defLoc = (apiLocationData || []).find(
							(x) => Number(x.ItemLocationId) === Number(defId)
						);
						opts = [
							{
								LocationId: Number(defId),
								LocationName: defLoc?.LocationName || 'Default location',
								Quantity: 0,
							},
						];
					}
				}
				let noStockLocationMsg = null;
				setRows((prevRows) => {
					const next = [...prevRows];
					if (!next[rowIndex]) return prevRows;
					const txLocId =
						next[rowIndex].locationId != null && next[rowIndex].locationId !== ''
							? Number(next[rowIndex].locationId)
							: 0;
					opts = ensureCheckoutLocationOptionForTransaction(
						opts,
						txLocId,
						apiLocationData
					);
					next[rowIndex].locationOptions = opts;
					const oldRowForEdit = editOldRowSnapshot || oldRows[rowIndex];
					const editCreditAtLoc = (locationId) =>
						getCheckoutOldQtyAtLocation(oldRowForEdit, locationId);
					const optionHasSelectableStock = (opt) => {
						if (checkoutLocationHasStock(opt)) return true;
						if (!isCheckoutEditContext(tranAction, formData.action)) return false;
						return editCreditAtLoc(opt.LocationId) > 0;
					};
					let selectedIds = (next[rowIndex].selectedLocationIds || []).filter((id) => {
						const opt = opts.find((o) => Number(o.LocationId) === Number(id));
						if (!opt) return false;
						if (isCheckoutEditContext(tranAction, formData.action)) {
							return optionHasSelectableStock(opt);
						}
						return checkoutLocationHasStock(opt);
					});
					if (
						selectedIds.length === 0 &&
						tranAction === 'edit' &&
						txLocId > 0
					) {
						selectedIds = [txLocId];
					}
					next[rowIndex].selectedLocationIds = selectedIds;
					if (isCheckoutEditContext(tranAction, formData.action)) {
						if (selectedIds.length === 1) {
							const credit = editCreditAtLoc(
								next[rowIndex].locationId || selectedIds[0]
							);
							Object.assign(
								next[rowIndex],
								syncCheckoutLocationAllocationsToQty(
									next[rowIndex],
									next[rowIndex].checkoutqty,
									credit
								)
							);
						} else {
							next[rowIndex].locationAllocations = buildLocationAllocations(
								selectedIds,
								opts,
								next[rowIndex].checkoutqty,
								oldRowForEdit
							);
						}
					} else if (usesSingleResolvedLocation()) {
						const patch = resolveLocationFieldsForTicketRow(
							next[rowIndex],
							opts,
							apiLocationData,
							checkoutQtyFieldForAction(formData.action)
						);
						if (patch) {
							Object.assign(next[rowIndex], patch);
						}
					} else {
						next[rowIndex].locationAllocations = buildLocationAllocations(
							selectedIds,
							opts,
							next[rowIndex].checkoutqty
						);
					}
					const rowRef = next[rowIndex];
					if (
						shouldRequireLocationSelection(rowRef) &&
						(parseFloat(rowRef.checkoutqty) || 0) > 0 &&
						opts.length > 0 &&
						!opts.some((opt) => locationOptionHasSelectableStock(opt, rowIndex))
					) {
						noStockLocationMsg = `Row ${rowIndex + 1}: All locations have no available quantity.`;
					}
					return next;
				});
				if (noStockLocationMsg) {
					flashCheckoutLocationMessage(noStockLocationMsg);
				}
			})
				.catch(() => {
					publishNotification('Unable to load checkout location stock.', 'error');
				});
	};

	const sumCheckoutForSameItem = (rowList, refRow) => {
		let s = 0;
		rowList.forEach((r) => {
			if (sameGridItem(refRow, r)) s += parseFloat(r.checkoutqty) || 0;
		});
		return s;
	};

	const sumCheckinForSameItem = (rowList, refRow) => {
		let s = 0;
		rowList.forEach((r) => {
			if (sameGridItem(refRow, r)) s += parseFloat(r.checkinqty) || 0;
		});
		return s;
	};

	const sumOldCheckoutForSameItem = (refRow) => {
		let s = 0;
		(oldRows || []).forEach((r) => {
			if (sameGridItem(refRow, r)) {
				s += parseFloat(r.checkoutqty) || parseFloat(r.checkinqty) || 0;
			}
		});
		return s;
	};

	const maxTotalCheckoutForItem = (rowList, refRow) => {
		if (isNonInventoryRow(refRow)) return Number.POSITIVE_INFINITY;
		const stock = parseFloat(refRow.qtyinstock) || 0;
		if (isCheckoutEditContext(tranAction, formData.action)) {
			return stock + sumOldCheckoutForSameItem(refRow);
		}
		if (isEditStockTransaction()) return stock + sumCheckinForSameItem(rowList, refRow);
		return stock;
	};

	const minAdjustmentQtyForItem = (refRow) => {
		if (isNonInventoryRow(refRow)) return Number.NEGATIVE_INFINITY;
		const stock = parseFloat(refRow.qtyinstock) || 0;
		const oldQty = tranAction === 'edit' ? sumOldCheckoutForSameItem(refRow) : 0;
		return oldQty - stock;
	};

	const clampAdjustmentQtyToStock = (rowList, index) => {
		const row = rowList[index];
		if (!row || (!row.itemid && !row.itemnumber)) return { clamped: false };
		const qty = parseFloat(row.checkoutqty);
		if (Number.isNaN(qty)) return { clamped: false };
		const minQty = minAdjustmentQtyForItem(row);
		if (qty + 1e-6 >= minQty) return { clamped: false };
		row.checkoutqty = minQty;
		row.totpri = (parseFloat(row.priperunit) || 0) * minQty;
		return { clamped: true };
	};

	const validateAllAdjustmentStock = (rowList) => {
		if (!shouldValidateAdjustmentStock()) return { ok: true };
		for (let i = 0; i < rowList.length; i++) {
			const row = rowList[i];
			if (!row || (!row.itemid && !row.itemnumber)) continue;
			if (isNonInventoryRow(row)) continue;
			const qty = parseFloat(row.checkoutqty);
			if (Number.isNaN(qty)) continue;
			if (qty + 1e-6 < minAdjustmentQtyForItem(row)) {
				return { ok: false, message: checkoutStockMsg };
			}
		}
		return { ok: true };
	};

	const flashStockError = () => {
		setErrorMessage(checkoutStockMsg);
		setTimeout(() => setErrorMessage(null), 5000);
		setCheckOutQtyMsg(checkoutStockMsg);
	};

	const validateAllCheckoutStock = (rowList) => {
		if (!shouldValidateCheckoutStock()) return { ok: true };
		const seen = new Set();
		for (let i = 0; i < rowList.length; i++) {
			const row = rowList[i];
			if (!row || (!row.itemid && !row.itemnumber)) continue;
			const key = row.itemid ? `id:${row.itemid}` : `n:${row.itemnumber}`;
			if (seen.has(key)) continue;
			seen.add(key);
			const totalCo = sumCheckoutForSameItem(rowList, row);
			const cap = maxTotalCheckoutForItem(rowList, row);
			if (totalCo > cap + 1e-6) return { ok: false, message: checkoutStockMsg };
		}
		return { ok: true };
	};

	const clampCheckoutQtyToStock = (rowList, index) => {
		const row = rowList[index];
		if (!row || (!row.itemid && !row.itemnumber)) return { clamped: false };
		const cap = maxTotalCheckoutForItem(rowList, row);
		const totalCo = sumCheckoutForSameItem(rowList, row);
		if (totalCo <= cap + 1e-6) return { clamped: false };
		const others = totalCo - (parseFloat(row.checkoutqty) || 0);
		const maxForRow = Math.max(0, cap - others);
		row.checkoutqty = maxForRow;
		row.totpri = (parseFloat(row.priperunit) || 0) * maxForRow;
		return { clamped: true };
	};

	// The handleInputChange handler can be set up to handle 
	// many different inputs in the form, listen for changes 
	// to input elements and record their values in state 
	const handleInputChange = (e, index) => { 
		setDisable(false); 

		
		const { name, value } = e.target;
		if (name === 'checkoutqty' && isReserveCreateOrderContext()) {
			return;
		} 
		const list = [...rows]; 
		var value1 = value;
		

		if(name == 'priperunit'  )
		{
			value1 = value.split('-').join('');
		}

		if(name == 'checkoutqty'  && formData.action == 'Adjustment')
		{
			
		}else{
			value1 = value.split('-').join('');
		}

		list[index][name] = value1;

		if (name === 'checkoutqty' && formData.action === 'Return') {
			list[index] = syncReturnRowQtyFields(list[index], value1);
		}

		
		
		if(name == 'itemid')
		{
			let accessToken = getAccessToken();
			const params = {
				itemid:  value1 ,
			  };

			apiClient.get(`/api/get/itembyid`  ,  { params: params ,headers: {"Authorization" : `Bearer ${accessToken}`} })
				.then(res => {
				const lookupItem = pickLookupItemFromResponse(res.data, value1);
				if (!lookupItem) {
					list[index]['itemid'] = 0;
					list[index]['qtyinstock'] = 0;
					list[index]['itemname'] = '';
					list[index]['cost'] = 0;
					resetCostReveal(getCostRowKey(list[index], index));
					list[index]['isNonInventory'] = false;
				list[index]['selectedLocationIds'] = [];
				list[index]['locationOptions'] = [];
				list[index]['locationAllocations'] = [];
					setRows(list);
					return;
				}
				list[index]['qtyinstock'] = lookupItem?.Quantity; 
				list[index]['itemname'] = lookupItem.ItemName; 
				list[index]['cost'] = lookupItem.Cost;
				resetCostReveal(getCostRowKey(list[index], index));
				list[index]['margin'] = lookupItem.Margin;
				list[index]['dynamicCost'] = lookupItem.DynamicCost;
				list[index]['itemnumber'] = lookupItem.ItemNumber; 
				list[index]['isNonInventory'] =
					lookupItem.IsNonInventory === 1 || lookupItem.IsNonInventory === true;
				list[index]['selectedLocationIds'] = [];
				list[index]['locationOptions'] = [];
				list[index]['locationAllocations'] = [];
				list[index]['paymentMethodId'] = formData.paymentMethodId; 
				if(name == 'priperunit')
				{
					list[index]['totpri'] = value1 * list[index]['checkoutqty'];
				}
		
				setRows(list); 
				fetchLocationStockForRow(lookupItem.ItemId, index);
			
				calculateTotals(list);

				})

		}
		
		else{

			
var paymentPerAmount = 0;
		
		if(name == 'priperunit' || name =='checkoutqty')
		{
			list[index]['totpri'] = list[index]['priperunit'] * list[index]['checkoutqty'];
			if (name === 'checkoutqty') {
				if (formData.action === 'Adjustment') {
					const patch = resolveLocationFieldsForTicketRow(
						list[index],
						list[index].locationOptions || [],
						apiLocationData
					);
					if (patch) {
						Object.assign(list[index], patch);
					}
				} else if (
					isCheckoutEditContext(tranAction, formData.action) &&
					(list[index].locationId ||
						(list[index].selectedLocationIds || []).length === 1)
				) {
					const credit = getRowEditLocationCredit(
						index,
						list[index].locationId ||
							(list[index].selectedLocationIds || [])[0]
					);
					Object.assign(
						list[index],
						syncCheckoutLocationAllocationsToQty(
							list[index],
							list[index].checkoutqty,
							credit
						)
					);
				} else {
					list[index]['locationAllocations'] = buildLocationAllocations(
						list[index]['selectedLocationIds'] || [],
						list[index]['locationOptions'] || [],
						list[index]['checkoutqty']
					);
				}
			}
			   var paymentPer = apiPaymentMethodData.filter(x=>x.PaymentMethodId == formData.paymentMethodId)[0]?.Percent??0;
			  paymentPerAmount = (list[index]['totpri'] * paymentPer) / 100;
			list[index]['paymentFee'] = list[index]['totpri'] + paymentPerAmount;
		}
		
		if(formData.action == 'Adjustment')
			{
				const decimalRegex = /^\-?\d*\.?\d{0,2}$/;  // /^-?\d{2}(\.\d+)?$/;

				if (decimalRegex.test(value1)) {
					if (name === 'checkoutqty' && shouldValidateAdjustmentStock()) {
						const { clamped } = clampAdjustmentQtyToStock(list, index);
						if (clamped) {
							flashStockError();
						} else {
							setCheckOutQtyMsg(null);
						}
					}
					setRows(list); 

					calculateTotals(list);
	
				}
			}else{
				const decimalRegex = /^\d*\.?\d{0,2}$/;
				if (decimalRegex.test(value1)) {
					if (name === 'checkoutqty') {
						if (isCheckoutEditContext(tranAction, formData.action)) {
							const locMsg = validateLocationForRow(list[index], index, { whileTyping: true });
							if (locMsg) {
								setErrorMessage(locMsg);
								setTimeout(() => setErrorMessage(null), 5000);
								setCheckOutQtyMsg(locMsg);
							} else {
								setCheckOutQtyMsg(null);
							}
						}
						if (shouldValidateCheckoutStock()) {
							list[index].totpri =
								(parseFloat(list[index].priperunit) || 0) *
								(parseFloat(list[index].checkoutqty) || 0);
							const { clamped } = clampCheckoutQtyToStock(list, index);
							if (
								clamped ||
								(!isNonInventoryRow(list[index]) &&
									parseFloat(list[index].qtyinstock) < 0)
							) {
								flashStockError();
							} else if (!isCheckoutEditContext(tranAction, formData.action)) {
								setCheckOutQtyMsg(null);
							}
						}
					}
					setRows(list);
	                calculateTotals(list);
				}
			}
		
				
		
		}

        
		
	}; 

	const isItemGridOptionInactive = (option) => {
		if (option == null || typeof option !== 'object') return false;
		const a = option.Active;
		return (
			a === false ||
			a === 0 ||
			String(a).toLowerCase() === 'false' ||
			String(a) === '0'
		);
	};

	const getItemGridOptionLabel = (option) => {
		if (option == null) return '';
		const num = option.ItemNumber != null ? String(option.ItemNumber) : '';
		const name = option.ItemName != null ? String(option.ItemName) : '';
		const base = num && name ? `${num} — ${name}` : num || name;
		if (!base) return '';
		return isItemGridOptionInactive(option) ? `${base} (Inactive)` : base;
	};

	const filterItemGridOptions = (options, state) => {
		const q = (state.inputValue || '').toLowerCase().trim();
		if (!q) return options;
		return options.filter((o) => {
			const num = String(o.ItemNumber != null ? o.ItemNumber : '').toLowerCase();
			const name = String(o.ItemName != null ? o.ItemName : '').toLowerCase();
			return num.includes(q) || name.includes(q);
		});
	};

	const findExactGridItemMatch = (input, options) => {
		const q = String(input || '').trim().toLowerCase();
		if (!q) return null;
		return (
			(options || []).find((o) => {
				const num = String(o.ItemNumber != null ? o.ItemNumber : '').toLowerCase();
				const name = String(o.ItemName != null ? o.ItemName : '').toLowerCase();
				return num === q || name === q;
			}) || null
		);
	};

	const applyCheckoutGridItem = (list, index, lookupItem) => {
		list[index]['qtyinstock'] = lookupItem?.Quantity;
		list[index]['itemname'] = lookupItem.ItemName;
		list[index]['itemnumber'] = lookupItem.ItemNumber;
		list[index]['entityGroupName'] = lookupItem.EntityGroupName || '';
		list[index]['categoryName'] = lookupItem.CategoryName || '';
		list[index]['cost'] = lookupItem.Cost;
		list[index]['margin'] = lookupItem.Margin;
		list[index]['dynamicCost'] = lookupItem.DynamicCost;
		list[index]['itemid'] = lookupItem.ItemId;
		list[index]['targetprice'] = lookupItem.TargetPrice;
		resetCostReveal(getCostRowKey(list[index], index));
		resetTargetPriceReveal(getTargetPriceRowKey(list[index], index));
		list[index]['isNonInventory'] =
			lookupItem.IsNonInventory === 1 || lookupItem.IsNonInventory === true;
		list[index]['selectedLocationIds'] = [];
		list[index]['locationOptions'] = [];
		list[index]['locationAllocations'] = [];
		list[index]['paymentMethodId'] = formData.paymentMethodId;
		if (shouldValidateCheckoutStock()) {
			list[index].totpri =
				(parseFloat(list[index].priperunit) || 0) * (parseFloat(list[index].checkoutqty) || 0);
			const { clamped } = clampCheckoutQtyToStock(list, index);
			if (clamped || (!isNonInventoryRow(list[index]) && parseFloat(list[index].qtyinstock) < 0)) {
				setErrorMessage(checkoutStockMsg);
				setTimeout(() => setErrorMessage(null), 5000);
				setCheckOutQtyMsg(checkoutStockMsg);
			} else {
				setCheckOutQtyMsg(null);
			}
		}
		setRows(list);
		fetchLocationStockForRow(lookupItem.ItemId, index);
		calculateTotals(list);
	};

	const handleInput2Change = (event, newInputValue, index, reason) => {
		if (reason === 'reset') return;
		const list = [...rows]; 
		if(pageName == 'transactions'  )
		{
			if(newInputValue != '')
			{
				
				list[index]['itemnumber'] = newInputValue;
		
				setRows(list); 
			}
			else if(isAdded)
			{
				
			list[index]['itemnumber'] = newInputValue;
	
			setRows(list); 
			}
			
		}
		else
		{
			list[index]['itemnumber'] = newInputValue;
	
			setRows(list); 
		}
	  };

	const handleAutoCompleteChange = (event, index, reason) => {
		if (reason !== 'clear') return;
		const list = [...rows];
		list[index]['itemid'] = 0;
		list[index]['paymentfee'] = 0;
		list[index]['qtyinstock'] = 0;
		list[index]['itemname'] = '';
		list[index]['itemnumber'] = '';
		list[index]['cost'] = '';
		list[index]['isNonInventory'] = false;
		list[index]['selectedLocationIds'] = [];
		list[index]['locationOptions'] = [];
		list[index]['locationAllocations'] = [];
		resetCostReveal(getCostRowKey(list[index], index));
		setRows(list);
	};

	const handleAutoCompleteBlur = (event, index) => {
		const itemNumberFromInput =
			event && event.target ? String(event.target.value || '').trim() : '';
		if (!itemNumberFromInput) return;
		const matched = findExactGridItemMatch(itemNumberFromInput, apiItemData);
		if (!matched) return;
		const list = [...rows];
		applyCheckoutGridItem(list, index, matched);
	};

	 

	const handleLocationSelectionChange = (index, selectedValues) => {
		const list = [...rows];
		const row = list[index];
		if (!row) return;
		const prev = (row.selectedLocationIds || []).map((v) => Number(v));
		const normalized = (selectedValues || [])
			.map((v) => Number(v))
			.filter((v) => !Number.isNaN(v));
		const added = normalized.filter((id) => !prev.includes(id));

		for (let a = 0; a < added.length; a += 1) {
			const opt = (row.locationOptions || []).find(
				(o) => Number(o.LocationId) === Number(added[a])
			);
			if (opt && !locationOptionHasSelectableStock(opt, index)) {
				flashCheckoutLocationMessage(checkoutLocationNoQtyMsg);
				return;
			}
		}

		const allowed = normalized.filter((id) => {
			const opt = (row.locationOptions || []).find((o) => Number(o.LocationId) === Number(id));
			if (!opt) return false;
			if (isCheckoutEditContext(tranAction, formData.action)) {
				return locationOptionHasSelectableStock(opt, index);
			}
			return checkoutLocationHasStock(opt);
		});

		row.selectedLocationIds = allowed;
		if (isCheckoutEditContext(tranAction, formData.action)) {
			if (allowed.length === 1) {
				const credit = getRowEditLocationCredit(index, allowed[0]);
				Object.assign(
					row,
					syncCheckoutLocationAllocationsToQty(row, row.checkoutqty, credit)
				);
			} else {
				row.locationAllocations = buildLocationAllocations(
					allowed,
					row.locationOptions || [],
					row.checkoutqty,
					oldRows[index]
				);
				row.locationId =
					allowed.length > 0 ? Number(allowed[0]) : '';
			}
		} else {
			row.locationAllocations = buildLocationAllocations(
				allowed,
				row.locationOptions || [],
				row.checkoutqty
			);
		}
		if (allowed.length > 0 && checkOutQtyMsg === checkoutLocationNoQtyMsg) {
			setCheckOutQtyMsg(null);
		}
		setRows(list);
	};

	const handlefocusOut = (e, index) => {
		setDisable(false);
		const { name, value } = e.target;
		if (name === 'checkoutqty' && isReserveCreateOrderContext()) {
			return;
		}
		const list = [...rows];
		list[index][name] = value;

		if (name === 'checkoutqty') {
			const rawNum = parseFloat(String(value).split('-').join(''));

			if (formData.action === 'Adjustment') {
				if (!isNaN(rawNum)) list[index].checkoutqty = parseFloat(value);
				list[index].totpri =
					(parseFloat(list[index].priperunit) || 0) *
					(parseFloat(list[index].checkoutqty) || 0);
				const { clamped } = clampAdjustmentQtyToStock(list, index);
				if (clamped) {
					flashStockError();
				} else {
					setCheckOutQtyMsg(null);
				}
			} else if (isReturnTransaction()) {
				if (parseFloat(value) > parseFloat(list[index].checkinqty)) {
					list[index][name] = list[index].checkinqty;
					const lim = parseFloat(list[index].checkinqty);
					const rmsg = 'Selected return item quantity should be less than or equal to ' + lim + '.';
					setErrorMessage(rmsg);
					setTimeout(() => setErrorMessage(null), 5000);
					setCheckOutQtyMsg(rmsg);
				} else {
					setCheckOutQtyMsg(null);
				}
				if (!isNaN(rawNum)) {
					list[index] = syncReturnRowQtyFields(list[index], rawNum);
				}
			} else if (isCheckoutEditContext(tranAction, formData.action)) {
				if (!isNaN(rawNum)) list[index].checkoutqty = rawNum;
				list[index].totpri =
					(parseFloat(list[index].priperunit) || 0) *
					(parseFloat(list[index].checkoutqty) || 0);
				if (
					list[index].locationId ||
					(list[index].selectedLocationIds || []).length === 1
				) {
					const credit = getRowEditLocationCredit(
						index,
						list[index].locationId ||
							(list[index].selectedLocationIds || [])[0]
					);
					Object.assign(
						list[index],
						syncCheckoutLocationAllocationsToQty(
							list[index],
							list[index].checkoutqty,
							credit
						)
					);
				}
				const locMsg = validateLocationForRow(list[index], index, { whileTyping: true });
				if (locMsg) {
					setErrorMessage(locMsg);
					setTimeout(() => setErrorMessage(null), 5000);
					setCheckOutQtyMsg(locMsg);
				} else {
					setCheckOutQtyMsg(null);
				}
				if (shouldValidateCheckoutStock()) {
					const { clamped } = clampCheckoutQtyToStock(list, index);
					if (
						clamped ||
						(!isNonInventoryRow(list[index]) && parseFloat(list[index].qtyinstock) < 0)
					) {
						flashStockError();
					}
				}
			} else if (shouldValidateCheckoutStock()) {
				if (!isNaN(rawNum)) list[index].checkoutqty = rawNum;
				list[index].totpri = (parseFloat(list[index].priperunit) || 0) * (parseFloat(list[index].checkoutqty) || 0);
				const { clamped } = clampCheckoutQtyToStock(list, index);
				if (clamped || (!isNonInventoryRow(list[index]) && parseFloat(list[index].qtyinstock) < 0)) {
					setErrorMessage(checkoutStockMsg);
					setTimeout(() => setErrorMessage(null), 5000);
					setCheckOutQtyMsg(checkoutStockMsg);
				} else {
					setCheckOutQtyMsg(null);
				}
			}
		}
		// Price warnings (below cost / below target) run only on Submit — not on line edit/blur
		if (name === 'checkoutqty' && !isCheckoutEditContext(tranAction, formData.action)) {
			list[index].locationAllocations = buildLocationAllocations(
				list[index].selectedLocationIds || [],
				list[index].locationOptions || [],
				list[index].checkoutqty
			);
		}

		setRows(list);
		calculateTotals(list);
	}; 

	// Showing delete confirmation to users 
	const handleConfirm = (index) => { 
		setShowConfirm(true); 
		setRowIndex(index);
	}; 

	// Handle the case of delete confirmation where 
	// user click yes delete a specific row of id:i 
	const handleRemoveClick = (i) => { 
		const list = [...rows]; 
		list.splice(rowIndex, 1); 
		setRows(list); 
		setShowConfirm(false); 
		if (shouldValidateCheckoutStock() && validateAllCheckoutStock(list).ok) {
			setCheckOutQtyMsg(null);
		}
		calculateTotals(list);
	}; 

	// Handle the case of delete confirmation 
	// where user click no 
	const handleNo = () => { 
		setShowConfirm(false); 
	}; 

	
   const handleChange = (event) => {
		const { name, value } = event.target;
		if (tranAction === 'edit' && name === 'customerId') return;
		formData[name] = value;
		setformData({ ...formData });
    };

	const rowHasSelectedItem = (row) => {
		const id = row.itemid;
		return id != null && id !== '' && Number(id) > 0;
	};

	const collectCheckoutValidationErrors = () => {
		const errors = [];
		const isNewTicket = tranEdit == null;
		const action = formData.action;

		if (isNewTicket) {
			if (!action) {
				errors.push('Select an action (CheckOut, Reserve or Adjustment).');
			}
			if (action && action !== 'Adjustment' && !(Number(formData.customerId) > 0)) {
				errors.push('Select a customer.');
			}
		}
		if (action === 'Adjustment' && !String(formData.reason || '').trim()) {
			errors.push('Enter a reason for the adjustment.');
		}

		if (!rows || rows.length === 0) {
			errors.push('Add at least one item to the order.');
			return errors;
		}

		const seenItemNumberRows = {};
		rows.forEach((row, idx) => {
			const rowLabel = `Row ${idx + 1}`;
			if (!rowHasSelectedItem(row)) {
				errors.push(`${rowLabel}: Select an item.`);
				return;
			}
			const normalizedItemNumber = String(row.itemnumber ?? '').trim().toLowerCase();
			if (normalizedItemNumber) {
				if (seenItemNumberRows[normalizedItemNumber] != null) {
					errors.push(
						`${rowLabel}: Item ${row.itemnumber} is already in row ${seenItemNumberRows[normalizedItemNumber] + 1}. Keep each item on one row.`
					);
				} else {
					seenItemNumberRows[normalizedItemNumber] = idx;
				}
			}
			if (action !== 'Adjustment' && tranAction !== 'return' && !(parseFloat(row.checkoutqty) > 0)) {
				errors.push(`${rowLabel}: Quantity must be greater than zero.`);
				return;
			}
			const locationMsg = validateLocationForRow(row, idx);
			if (locationMsg) errors.push(locationMsg);
		});

		if (shouldValidateCheckoutStock()) {
			const stockRes = validateAllCheckoutStock(rows);
			if (!stockRes.ok) errors.push(stockRes.message);
		}
		if (shouldValidateAdjustmentStock()) {
			const adjRes = validateAllAdjustmentStock(rows);
			if (!adjRes.ok) errors.push(adjRes.message);
		}

		return errors;
	};

	const validationMessageTimerRef = React.useRef(null);
	const showValidationErrors = (errors) => {
		if (validationMessageTimerRef.current) clearTimeout(validationMessageTimerRef.current);
		const message =
			errors.length === 1
				? errors[0]
				: ['Please fix the following before submitting:', ...errors.map((e) => `• ${e}`)].join('\n');
		setErrorMessage(message);
		validationMessageTimerRef.current = setTimeout(() => setErrorMessage(null), 15000);
	};

	const submit = (cancelAllReserve = false, skipBelowCostCheck = false, skipBelowTargetCheck = false) => {
		let qtyValidationAllowsSubmit = checkOutQtyMsg == null;
		// Collect every problem first and show them together, instead of
		// stopping at the first one (location, then quantity, then customer...).
		const validationErrors = collectCheckoutValidationErrors();
		if (validationErrors.length > 0) {
			showValidationErrors(validationErrors);
			return;
		}
		if (shouldValidateCheckoutStock()) {
			setCheckOutQtyMsg(null);
			qtyValidationAllowsSubmit = true;
		}

		if( (formData.action == 'Adjustment' || (formData.customerId > 0  && formData.action == 'Reserve') || (formData.customerId > 0 && formData.action != 'Adjustment' && formData.action != 'Reserve')) && rows.length > 0   && (rows[0].checkoutqty > 0 || formData.action == 'Adjustment' || tranAction == 'return') && formData.action != ''  &&  qtyValidationAllowsSubmit && (formData.action != 'Adjustment' || (formData.reason !== null && formData.reason !== undefined && formData.reason !== '')) || tranEdit != undefined)
		{
			if (isCheckoutSale()) {
				if (!skipBelowCostCheck) {
					const belowCostRows = getBelowCostCheckoutRows(rows);
					if (belowCostRows.length > 0) {
						setPendingSubmitCancelAllReserve(cancelAllReserve);
						setPendingBelowCostSubmit(true);
						setBelowCostWarningItems(belowCostRows);
						setShowConfirmBelowCost(true);
						return;
					}
				}
				if (!skipBelowTargetCheck) {
					const belowTargetRows = getBelowTargetPriceCheckoutRows(rows);
					if (belowTargetRows.length > 0) {
						setPendingSubmitCancelAllReserve(cancelAllReserve);
						setPendingBelowTargetSubmit(true);
						setBelowTargetPriceWarningItems(belowTargetRows);
						setShowConfirmTargetPrice(true);
						return;
					}
				}
			}

			let user = JSON.parse(sessionStorage.getItem('user'));
        let accessToken = user.accessToken;
		let userId = user.userId;
		var customerName = '';
		const editTicketNumber = tranEdit?.TicketNumber || formData.ticketNumber;
		const normalizeSubmitRow = (row) => {
			const qty = resolveSubmitCheckoutQty(row, formData.action);
			const unitPrice = parseFloat(row.priperunit) || 0;
			const rowWithQty = {
				...row,
				checkoutqty: qty,
				totpri: unitPrice * qty,
				...(formData.action === 'Return' ? { checkinqty: qty } : {}),
			};
			return syncCheckoutRowLocationAllocations(
				normalizeCheckoutRowLocationForTransaction(
					rowWithQty,
					apiLocationData,
					formData.action
				),
				tranAction,
				formData.action
			);
		};
		const rowsForSubmit = rows.map(normalizeSubmitRow);
		const oldRowsForSubmit = oldRows.map(normalizeSubmitRow);
		var data = {};

		

		if(formData.action == 'Adjustment')
		{
			data = {oldItemData:oldRowsForSubmit,itemData:rowsForSubmit, date: moment(formData.date).format('MM-DD-YYYY'),customerId:formData.customerId,action:formData.action,customerName:customerName,userId:userId,ponumber:formData.ponumber,ticketNumber:editTicketNumber,reason:formData?.reason,tranAction:tranAction, cancelAllReserve: false}
		}
		else if(formData.action == 'Reserve'){
			customerName = (apiVendorData.filter(x=>x.CustomerId == formData.customerId)[0]).CustomerName;
			if(cancelAllReserve == true)
			data = {oldItemData:oldRowsForSubmit,itemData:rowsForSubmit, date: moment(formData.date).format('MM-DD-YYYY'),customerId:formData.customerId,action:formData.action,customerName:customerName,userId:userId,ponumber:formData.ponumber,ticketNumber:editTicketNumber,reason:formData?.reason,tranAction:tranAction, cancelAllReserve: true}
		else{
			data = {oldItemData:oldRowsForSubmit,itemData:rowsForSubmit, date: moment(formData.date).format('MM-DD-YYYY'),customerId:formData.customerId,action:formData.action,customerName:customerName,userId:userId,ponumber:formData.ponumber,ticketNumber:editTicketNumber,reason:formData?.reason,tranAction:tranAction, cancelAllReserve: false}
		}
		}
		else{
			customerName = (apiVendorData.filter(x=>x.CustomerId == formData.customerId)[0]).CustomerName;
			data = {oldItemData:oldRowsForSubmit,itemData:rowsForSubmit, date: moment(formData.date).format('MM-DD-YYYY'),customerId:formData.customerId,action:formData.action,customerName:customerName,userId:userId,ponumber:formData.ponumber,ticketNumber:editTicketNumber,reason:formData?.reason,tranAction:tranAction, cancelAllReserve: false}
		}

		data.broker1CustomerId = formData.action === 'CheckOut' ? formData.broker1CustomerId || null : null;
		data.broker2CustomerId = formData.action === 'CheckOut' ? formData.broker2CustomerId || null : null;
		data.broker3CustomerId = formData.action === 'CheckOut' ? formData.broker3CustomerId || null : null;

		if (formData.action === 'CheckOut') {
			data.commissionData = commissionRows.filter((c) => c.commissionId);
		}
		
		setloading(true);
			apiClient.post(`/api/post/transactionCheckOut`, { data }, { headers: {"Authorization" : `Bearer ${accessToken}`} })
			.then(res => {
			  refreshCheckoutItemCatalog();

			  setTimeout(() => {
				setSuccessMessage('Successfully submitted!');
			  }, 1000);
	
			setTimeout(() => {
			  setSuccessMessage(null); 
			  setloading(false);
			  setInvoiceType('internal');
			  settranDetail({
					items: rows,
					TotalTicketPrice: grandTotal,
					TotalPaymentFee: paymentFee,
					TotalCommission: commissionTotal,
					InvoiceSubtotal: invoiceSubtotal,
					commissions: commissionRows.filter((c) => c.commissionId),
					TicketNumber: res.data.data,
					PONumber: '',
					Date: new Date(),
					UserName: '',
					VendorName: customerName,
					CustomerName: customerName,
					Broker1CustomerId: formData.broker1CustomerId || null,
					Broker2CustomerId: formData.broker2CustomerId || null,
					Broker3CustomerId: formData.broker3CustomerId || null,
					Broker1Name: apiVendorData.find((x) => x.CustomerId == formData.broker1CustomerId)?.CustomerName || '',
					Broker2Name: apiVendorData.find((x) => x.CustomerId == formData.broker2CustomerId)?.CustomerName || '',
					Broker3Name: apiVendorData.find((x) => x.CustomerId == formData.broker3CustomerId)?.CustomerName || '',
				})
			  setshowTranDetail(true);
			  // Embedded in Transactions edit dialog: do not call onSendValue yet —
			  // parent closes/unmounts this form and would hide the detail dialog.
			  // Refresh runs when the detail dialog is closed (see closeTransDetailDialog).
			  if (!embeddedInDialog && typeof props.onSendValue === 'function') {
				props.onSendValue();
			  }
			 
			
			 
			}, 2000);
	
			})
			.catch((error) => {
				setloading(false);
				const message = error?.response?.data?.error || 'Unable to update the ticket.';
				setErrorMessage(message);
				setTimeout(() => setErrorMessage(null), 5000);
			});
	
		
		
		

		}
		else
		{
			var errorMsg = 'Please check and select the following , ';

			
			if(formData.action == 'Adjustment')
			{
				
				if(formData.action == "" )
								{
									errorMsg += 'Type of Transaction under "Select Action", ';
									
								}
								 if (rows.length == 0 )
								{
									errorMsg += 'Order cannot be empty, \r\n';
								}

								 if (formData.reason == undefined || formData.reason == '' || formData.reason == null)
								{
									errorMsg += 'Reason cannot be empty, \r\n';
								}

								
								setTimeout(() => {
									setErrorMessage(errorMsg);
								}, 1000);
			if(rows[0].checkoutqty == 0)
			{
				errorMsg += 'Qty cannot be zero, ';
			}

				
				
			}
			else
			{
				if(formData.action == 'Reserve')
				{
					
									if(formData.action == "" )
								{
									errorMsg += 'Action, \r\n';
									
								}
								 if (rows.length == 0 )
								{
									errorMsg += 'Order,  \r\n';
								}
								if(formData.customerId == null )
								{
									errorMsg += 'Customer, \r\n';
									
								}
								if(formData.ponumber == '' )
								{
									errorMsg += 'PO Number \r\n';
								}
								errorMsg += '. Pls fill out the required fields.';
								setTimeout(() => {
									setErrorMessage(errorMsg);
								}, 1000);

				}else{
					
					if(formData.action == "" )
					{
						errorMsg += 'Action, \r\n';
						
					}
					 if (rows.length == 0 )
					{
						errorMsg += 'Order,  \r\n';
					}
					if(formData.customerId == null )
					{
						errorMsg += 'Customer, \r\n';
						
					}
					
					if(formData.checkoutqty == undefined || formData.checkoutqty == 0 	){
						errorMsg += 'Qty cannot be zero, ';
					}
					errorMsg += '. Please provide required things.';
					
					setTimeout(() => {
						setErrorMessage(errorMsg);
					}, 1000);

				}
				
			}

			if(checkOutQtyMsg != null)
			{
				setTimeout(() => {
					setErrorMessage(checkOutQtyMsg);
				}, 1000);

			}

			
			
			
			setTimeout(() => {
			  setErrorMessage(null); 
			 

		}, 10000);

		
					
					

		

		}

	};

    const handleSubmit = (cancelAllReserve = false) => {

		if(tranEdit == null)
		{
			submit();
		}else{
			if((formData?.reason != null && formData?.reason != '') || tranAction =='return' || tranAction =='return-order')
			{
				submit(cancelAllReserve);
			}else{
				setTimeout(() => {
					setErrorMessage('Pleave provide reason for transaction edit.');
				}, 1000);
				 
				setTimeout(() => {
				  setErrorMessage(null); 
				}, 5000);
			}
		}
		
       
        
    };

return ( 
	<div className="CheckOut">
		<h2>
		{
		
		tranEdit == null?(
			 'Invoice' + (tranAction =='edit'?' Edit': tranAction =='return'?' Return':'')
		):(
            formData.action == 'CheckOut'?'Invoice' + (tranAction =='edit'?' Edit': tranAction =='return'?' Return':'') : tranAction == 'return-order'?'Create Order': formData.action == 'Reserve'? 'Reserve ' + (tranAction =='edit'?' Edit':''): formData.action =='Reserve'?' Reserve' + (tranAction =='edit'?' Edit':''): formData.action =='Return'?' Return': 'Product Adjustments '
		)
		
}
			
			</h2>
	<TableBody> 
	<Snackbar 
		open={open} 
		autoHideDuration={2000} 
		onClose={handleClose} 
		className={classes.snackbar}> 
		<Alert onClose={handleClose} severity="success"> 
		Record saved successfully! 
		</Alert> 
	</Snackbar> 
	<Box margin={1}> 
		<TableRow align="center"></TableRow> 
		<div >
		{tranAction == 'return' || tranAction == 'return-order'  ? ( <div>
			<div>  { (tranAction =='return'?' Return ': '') + 'Ticket Number : ' + formData.ticketNumber}</div>
				<div>Customer Name : {formData.customerName}</div>
			
				
			<div>PO Number : {formData.ponumber}</div>
			<div>User : {formData.user}</div>
			<div><FormControl  margin="normal">
			<MuiPickersUtilsProvider utils={DateFnsUtils}>
				<DatePicker
					label="Select Date"
					name="date"
					format="MM/dd/yyyy"
					value={tranAction == 'return-order'  ? new Date() : formData.date}
					onChange={handleDateChange}
					displayEmpty
					margin="normal"
				/>
				</MuiPickersUtilsProvider>
			</FormControl></div>
			
		</div>)
	:
	(
<div className="checkout-form-columns">
<div className="checkout-form-main">
{(tranAction == 'edit' && getTransactionType(formData.ticketNumber) == 'Product Return') &&
			(
				<div>
 					{'Return Ticket Number : ' + formData.returnTicketNumber }
				</div>
			)
			}
<div >
			<FormControl  margin="normal">
			<MuiPickersUtilsProvider utils={DateFnsUtils}>
				<DatePicker
					label="Select Order Date"
					name="date"
					format="MM/dd/yyyy"
					value={formData.date}
					onChange={handleDateChange}
					displayEmpty
					margin="normal"
				/>
				</MuiPickersUtilsProvider>
			</FormControl>
			</div>
{(formData.action !='Return' && tranEdit == null) && (
<div >
			<FormControl  margin="normal">
						<InputLabel id="select-label">Select Action</InputLabel>
						<Select
										label="Action"
										name="action" 
										value={formData.action}
										onChange={(e) => handleChange(e)}

										margin="normal"
										displayEmpty
										inputProps={{ 'aria-label': 'Without label' }} >
									<MenuItem value="CheckOut">  CheckOut</MenuItem>
									<MenuItem value="Reserve">  Reserve</MenuItem>
							{user.permissions.filter(x=>x.PermissionName == 'Adjustment Product' && x.PermissionAllowed == 1).length > 0 && <MenuItem value="Adjustment">  Adjustment</MenuItem> }		

										
						 </Select>  
           </FormControl>
			</div>


)}


			
			<div >
			
		   <TextField 
        label="PO Number"
		className={classes.customTextField}
        variant="filled"
	
		InputLabelProps={{
			style: { textAlign: 'left' },
		  }}
        name="ponumber"
        value={formData.ponumber}
        onChange={(e) => handleChange(e)}
      />
			</div>
			
			<div >
			<FormControl  margin="normal">
        {(tranEdit == null || formData.customerId == null) && ( <InputLabel id="select-label">Select Customer</InputLabel>)} 
          <Select
                        label="Customer"
						name="customerId" 
                        value={formData.customerId}
						onChange={(e) => handleChange(e)}
						disabled={tranAction === 'edit'}

						margin="normal"
                      
                        inputProps={{ 'aria-label': 'Without label' }} >
                      <MenuItem value=''>  select Customer</MenuItem>
					   <MenuItem value=''> </MenuItem>
                        {apiVendorData.map((item) => (
                        <MenuItem value={item.CustomerId}>  {item.CustomerName}</MenuItem>
                        ))}
						 </Select>  
        </FormControl>
			 

			</div>
	{(formData.action =='CheckOut') && (
			<div>
								<FormControl  margin="normal">
								 <InputLabel id="select-label">Payment Method</InputLabel>
								
									<Select
											label="PaymentMethod"
											name="paymentMethodId" 
											value={formData.paymentMethodId}
											onChange={(e) => {handleChange(e); calculateTotals();}}
											placeholder="Payment Method"
											margin="normal"
											inputProps={{ 'aria-label': 'Without label' }} >
											<MenuItem value=''>  select Payment Method</MenuItem>
											{apiPaymentMethodData.map((item) => (
											<MenuItem value={item.PaymentMethodId}>  {item.Name}</MenuItem>
											))}
									</Select>  
							</FormControl>
			
						</div>
	)}		

			{(tranEdit != null ||  formData.action == 'Adjustment') &&(
		<div >
			
			<TextField  
			 multiline
			 rows={4} // Specify the number of visible rows
			 rowsMax={10} // Specify the maximum number of rows
			label="reason"
			
			className={classes.customTextField}
			variant="filled"
		
			InputLabelProps={{
				style: { width: '200px', textAlign: 'left' },
			}}
			name="reason"
			value={formData.reason}
			onChange={(e) => handleChange(e)}
		/>

	</div>
	)}

</div>
	{(formData.action =='CheckOut') && (
		<div className="checkout-broker-column">
			{[1, 2, 3].map((brokerNumber) => (
				<div key={`broker-${brokerNumber}`}>
					<FormControl margin="normal">
						<InputLabel id={`broker-${brokerNumber}-label`}>{`Broker #${brokerNumber}`}</InputLabel>
						<Select
							labelId={`broker-${brokerNumber}-label`}
							label={`Broker #${brokerNumber}`}
							name={`broker${brokerNumber}CustomerId`}
							value={formData[`broker${brokerNumber}CustomerId`] || ''}
							onChange={handleChange}
							margin="normal"
						>
							<MenuItem value=""><em>None</em></MenuItem>
							{apiVendorData.map((item) => (
								<MenuItem key={item.CustomerId} value={item.CustomerId}>{item.CustomerName}</MenuItem>
							))}
						</Select>
					</FormControl>
				</div>
			))}
		</div>
	)}
</div>

	)}
				
			<div style={{ display: "flex", justifyContent: "space-between", marginTop:"20px" }}> 
		
		{
			
			((tranAction == undefined || tranAction?.indexOf('return') == -1) &&  !(tranAction == 'edit' && getTransactionType(formData.ticketNumber) == 'Product Return') ) &&

			(
				<div> 
				<div className="alignDiv">
						<Button onClick={handleAdd}> 
						<AddBoxIcon onClick={handleAdd} /> 
						ADD 
						</Button> 
						</div>

						<div className="alignDiv">
						<Button onClick={handleAddBarcode}> 
						<AddBoxIcon onClick={handleAddBarcode} /> 
						Add by Barcode Reader
						</Button> 
						</div>
				</div> 
			)
		}
		
		</div> 
		<div
			style={{ marginTop: '10px' }}
			className={embeddedInDialog ? 'transaction-edit-grid checkout-line-grid' : 'checkout-line-grid'}
		>
		<Table 
			className={tableClassName} 
			size="small"
			aria-label="a dense table"
			> 
		<TableHead> 
			<TableRow className={classes.tableHeader} > 
			<TableCell className={`${tableCellClass} grid-col-item`} >Item Number</TableCell> 
			<TableCell className={`${tableCellClass} grid-col-name`} >Item Name</TableCell>
			<TableCell className={`${tableCellClass} grid-col-stock`}  align="center">Qty In Stock</TableCell> 
			{isCostDisplayContext() && (
				<TableCell className={`${tableCellClass} sensitive-value-cell grid-col-cost`} align="center">Cost</TableCell>
			)}
			<TableCell className={`${tableCellClass} sensitive-value-cell grid-col-target`} align="center">Target Price</TableCell>
			<TableCell className={`${tableCellClass} grid-col-qty`}  align="center">Qty</TableCell> 
			<TableCell className={`${tableCellClass} grid-col-location`}  align="center">Location</TableCell> 
			<TableCell className={`${tableCellClass} grid-col-price`}  align="center">Price per unit</TableCell> 
			<TableCell className={`${tableCellClass} grid-col-total`}  align="center">Total Price</TableCell> 
			<TableCell className={`${tableCellClass} grid-col-actions`}  align="center"></TableCell> 
			</TableRow> 
		</TableHead> 
		<TableBody> 
			{rows.map((row, i) => {   
			return ( 
				
				<TableRow className={classes.tableRow} > 
					
						{isEdit ? (
						<TableCell className={tableCellClass}    component="th" scope="row"> 
						
					
						{(tranAction == undefined || tranAction?.indexOf('return') == -1)  ?
			(
				<Autocomplete
						id="itemid"
						name="itemid"
						autoSelect={false}
						inputValue={row.itemnumber}
						options={apiItemData}
						onInputChange={(event, newValue, reason) => {
							
							handleInput2Change(event, newValue, i, reason);
						
						  }}
						onChange={(event, newValue, reason) => {
							if (reason === 'select-option' && newValue && typeof newValue === 'object') {
								const list = [...rows];
								applyCheckoutGridItem(list, i, newValue);
								return;
							}
								handleAutoCompleteChange(event,i,reason);
						
						  }}
						  onBlur={(event, newValue, reason) => {
							
								handleAutoCompleteBlur(event,i,reason);
						
						  }}
						 
						getOptionLabel={(option) => getItemGridOptionLabel(option)}
						filterOptions={filterItemGridOptions}
						style={{
							minWidth: 0,
							width: '100%',
							maxWidth: '100%',
							border: null,
						}}
						renderInput={(params) => (
							<TextField {...params} variant="standard" placeholder="Number or name…" />
						)}
						
						/>
			):(

				row.itemnumber
			)}
					
						</TableCell> 
						):(
						<TableCell className={tableCellClass}  component="th" scope="row"> 
						{row.item} 
						</TableCell> 
						)}

                       {isEdit ? (
						  <TableCell padding="none"> 
                          <input 
						  disabled
                            value={row.itemname} 
                            name="itemname"
                            onChange={(e) => handleInputChange(e, i)} 
                          /> 
                        </TableCell> 
						):(
							<TableCell className={tableCellClass}  component="th" scope="row" align="center"> 
						{row.itemname} 
						</TableCell> 
						)}

						{isEdit ? (
						  <TableCell padding="none"  style={{   textAlign:"right" }}> 
                          <input 
						  disabled
						  style={{   textAlign:"right" }}
                            value={parseFloat(row.qtyinstock)?.toFixed(2)} 
                            name="qtyinstock"
                            onChange={(e) => handleInputChange(e, i)} 
                          /> 
                        </TableCell> 
						):(
							<TableCell className={tableCellClass}  component="th" scope="row" align="right"> 
						{parseFloat(row.qtyinstock)?.toFixed(2)}
						</TableCell>
						)}

							{isCostDisplayContext() && (isEdit ? (
							  <TableCell
							    className="sensitive-value-cell"
							    padding="none"
							    style={{ textAlign: 'right' }}
							  >
							    <button
							      type="button"
							      className="sensitive-value-input"
							      tabIndex={hasCostValue(row.cost) ? 0 : -1}
							      style={{
							        textAlign: 'right',
							        cursor: hasCostValue(row.cost) ? 'pointer' : 'default',
							        border: 'none',
							        background: 'transparent',
							      }}
							      name="cost"
							      aria-label={isCostRevealed(getCostRowKey(row, i)) ? 'Hide cost' : 'Show cost'}
							      aria-pressed={isCostRevealed(getCostRowKey(row, i))}
							      onClick={() => {
							        if (hasCostValue(row.cost)) {
							          toggleCostVisibility(getCostRowKey(row, i));
							        }
							      }}
							      onBlur={() => hideCost(getCostRowKey(row, i))}
							    >
							      {getCostDisplay(row, i)}
							    </button>
							  </TableCell>
							) : (
							  <TableCell
							    className={`${tableCellClass} sensitive-value-cell`}
							    component="th"
							    scope="row"
							    align="right"
							    style={{ cursor: hasCostValue(row.cost) ? 'pointer' : 'default' }}
							    role="button"
							    tabIndex={hasCostValue(row.cost) ? 0 : -1}
							    aria-label={isCostRevealed(getCostRowKey(row, i)) ? 'Hide cost' : 'Show cost'}
							    aria-pressed={isCostRevealed(getCostRowKey(row, i))}
							    onClick={(e) => {
							      if (!hasCostValue(row.cost)) return;
							      e.currentTarget.focus();
							      toggleCostVisibility(getCostRowKey(row, i));
							    }}
							    onKeyDown={(e) => {
							      if (!hasCostValue(row.cost) || (e.key !== 'Enter' && e.key !== ' ')) return;
							      e.preventDefault();
							      toggleCostVisibility(getCostRowKey(row, i));
							    }}
							    onBlur={() => hideCost(getCostRowKey(row, i))}
							  >
							    {getCostDisplay(row, i)}
							  </TableCell>
							))}

{isEdit ? (
						  <TableCell
						    className="sensitive-value-cell"
						    padding="none"
						    style={{ textAlign: 'right' }}
						  >
					  <button
						  type="button"
						  className="sensitive-value-input"
						  tabIndex={hasTargetPriceValue(row.targetprice) ? 0 : -1}
						  style={{
						    textAlign: 'right',
						    cursor: hasTargetPriceValue(row.targetprice) ? 'pointer' : 'default',
						    border: 'none',
                            background: 'transparent',
						  }}
                            name="targetprice"
							aria-label={isTargetPriceRevealed(getTargetPriceRowKey(row, i)) ? 'Hide target price' : 'Show target price'}
							aria-pressed={isTargetPriceRevealed(getTargetPriceRowKey(row, i))}
							onClick={() => {
							  if (hasTargetPriceValue(row.targetprice)) {
							    toggleTargetPriceVisibility(getTargetPriceRowKey(row, i));
							  }
							}}
							onBlur={() => hideTargetPrice(getTargetPriceRowKey(row, i))}
						  >
							{getTargetPriceDisplay(row, i)}
						  </button>
                        </TableCell> 
						):(
							<TableCell
							  className={`${tableCellClass} sensitive-value-cell`}
							  component="th"
							  scope="row"
							  align="right"
							  style={{
							    cursor: hasTargetPriceValue(row.targetprice) ? 'pointer' : 'default',
							  }}
							  role="button"
							  tabIndex={hasTargetPriceValue(row.targetprice) ? 0 : -1}
							  aria-label={isTargetPriceRevealed(getTargetPriceRowKey(row, i)) ? 'Hide target price' : 'Show target price'}
							  aria-pressed={isTargetPriceRevealed(getTargetPriceRowKey(row, i))}
							  onClick={(e) => {
								if (!hasTargetPriceValue(row.targetprice)) return;
								e.currentTarget.focus();
								toggleTargetPriceVisibility(getTargetPriceRowKey(row, i));
							  }}
							  onKeyDown={(e) => {
								if (!hasTargetPriceValue(row.targetprice) || (e.key !== 'Enter' && e.key !== ' ')) return;
								e.preventDefault();
								toggleTargetPriceVisibility(getTargetPriceRowKey(row, i));
							  }}
							  onBlur={() => hideTargetPrice(getTargetPriceRowKey(row, i))}
							>
						{getTargetPriceDisplay(row, i)}
						</TableCell> 
						)}


						
						{isEdit ? ( 
						  <TableCell padding="none"  style={{   textAlign:"right" }}> 
                          {isReserveCreateOrderContext() ? (
							row.checkoutqty
						  ) : (
                          <input 
						   type="Number"
                            value={row.checkoutqty} 
							style={{   textAlign:"right" }}
                            name="checkoutqty"
							min={1}
                            onChange={(e) => handleInputChange(e, i)} 
							   	onBlur={(e) => handlefocusOut(e, i)} 
                          />
						  )}
                        </TableCell> 
						):(
							<TableCell className={tableCellClass}  component="th" scope="row" align="right"> 
						{row.checkoutqty} 
						</TableCell> 
						)}

{isEdit ? (
						  <TableCell padding="none" style={{ textAlign:"left" }}>
							<FormControl fullWidth size="small">
								<Select
									multiple
									value={row.selectedLocationIds || []}
									onChange={(e) => handleLocationSelectionChange(i, e.target.value)}
									displayEmpty
									renderValue={(selected) =>
										formatCheckoutLocationRenderLabel(row, selected, (loc) =>
											isCheckoutEditContext(tranAction, formData.action)
												? getCheckoutEditLocationEffectiveAvailable(loc.Quantity, oldRows[i], loc.LocationId)
												: parseFloat(loc.Quantity) || 0
										)
									}
								>
									{(row.locationOptions || []).map((loc) => {
										const editCredit = getRowEditLocationCredit(i, loc.LocationId);
										const displayQty = isCheckoutEditContext(tranAction, formData.action)
											? getCheckoutEditLocationEffectiveAvailable(
													loc.Quantity,
													oldRows[i],
													loc.LocationId
												)
											: parseFloat(loc.Quantity) || 0;
										const hasStock = locationOptionHasSelectableStock(loc, i);
										const isChecked =
											(row.selectedLocationIds || []).indexOf(loc.LocationId) > -1;
										const keepSelectedOnEdit =
											tranAction === 'edit' && isChecked;
										return (
											<MenuItem
												key={`${row.itemid || 'row'}-loc-${loc.LocationId}`}
												value={loc.LocationId}
												disabled={!hasStock && !keepSelectedOnEdit}
											>
												<Checkbox checked={isChecked} disabled={!hasStock} />
												{`${loc.LocationName} - ${toFixedQty(displayQty)}${
													!hasStock ? ' (no quantity)' : ''
												}${
													editCredit > 0 && displayQty > (parseFloat(loc.Quantity) || 0)
														? ` (${toFixedQty(loc.Quantity)} + ${toFixedQty(editCredit)} from ticket)`
														: ''
												}`}
											</MenuItem>
										);
									})}
								</Select>
							</FormControl>
						  </TableCell>
						):(
							<TableCell className={tableCellClass} component="th" scope="row" align="left">
								{(row.locationAllocations || [])
									.map((a) => `${a.locationName} (${toFixedQty(a.quantity)})`)
									.join(', ')}
							</TableCell>
						)}

{isEdit ? ( 
						  <TableCell padding="none"  style={{   textAlign:"right" }}> 
						  {(tranAction == undefined || tranAction?.indexOf('return') == -1) ?
			(
				<input 
				type="Number"
				style={{   textAlign:"right" }}
				 value={row.priperunit} 
				 name="priperunit"
				 min={1}
				 onChange={(e) => handleInputChange(e, i)} 
				 onBlur={(e) => handlefocusOut(e, i)} 
			   /> 
			):(
				row.priperunit
			)}
                         
                        </TableCell> 
						):(
							<TableCell className={tableCellClass}  component="th" scope="row" align="right"> 
						{row.priperunit.toLocaleString()} 
						</TableCell> 
						)}

{isEdit ? ( 
						  <TableCell padding="none" style={{   textAlign:"right" }}> 
                          {row.totpri.toLocaleString()} 
                        </TableCell> 
						):(
							<TableCell className={tableCellClass} style={{   textAlign:"right" }}  component="th" scope="row" align="right"> 
						{row.totpri.toLocaleString()} 
						</TableCell> 
						)}

		
	<TableCell  className={tableCellClass} 
						component="th"
						scope="row"
						align="center"
						>
							 {(tranAction == undefined || tranAction?.indexOf('return') == -1) &&
			(
				<Button className="mr10" onClick={(e) => handleConfirm(i)}> 
									<DeleteOutlineIcon /> 
								</Button> 
			)}
								
								
							
							</TableCell> 

					
					
					
					{showConfirm && ( 
					<div> 
						<Dialog 
						open={showConfirm} 
						onClose={handleNo} 
						aria-labelledby="alert-dialog-title"
						aria-describedby="alert-dialog-description"
						> 
						<DialogTitle id="alert-dialog-title"> 
							{"Confirm Delete"} 
						</DialogTitle> 
						<DialogContent> 
							<DialogContentText id="alert-dialog-description"> 
							Are you sure to delete
							</DialogContentText> 
						</DialogContent> 
						<DialogActions> 
							<Button 
							onClick={() => handleRemoveClick(i)} 
							color="primary"
							autoFocus 
							> 
							Yes 
							</Button> 
							<Button 
							onClick={handleNo} 
							color="primary"
							autoFocus 
							> 
							No 
							</Button> 
						</DialogActions> 
						</Dialog> 
					</div> 
					)} 
				</TableRow> 
				
			); 
			})} 
		</TableBody> 
		</Table> 

		</div>

		{isCheckoutCommissionForm() && (
			<div style={{ marginTop: '24px' }}>
				<div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px' }}>
					<div className="alignDiv">
						<Button onClick={handleAddCommission}>
							<AddBoxIcon />
							ADD COMMISSION
						</Button>
					</div>
				</div>
				<Table size="small" aria-label="commission grid" style={{ marginTop: '10px' }}>
					<TableHead>
						<TableRow className={classes.tableHeader}>
							<TableCell className={tableCellClass}>Commission</TableCell>
							<TableCell className={tableCellClass}>Description</TableCell>
							<TableCell className={tableCellClass} align="center">
								Value
							</TableCell>
							<TableCell className={tableCellClass} align="right">
								Commission Amount
							</TableCell>
							<TableCell className={tableCellClass} align="center" />
						</TableRow>
					</TableHead>
					<TableBody>
						{commissionRows.map((cRow, ci) => {
							const valueMeta = getCommissionValueFieldMeta(cRow.commissionType);
							return (
								<TableRow key={`commission-${cRow.id}`} className={classes.tableRow}>
									<TableCell padding="none">
										<Select
											value={cRow.commissionId || ''}
											onChange={(e) => handleCommissionSelect(e, ci)}
											displayEmpty
											style={{ minWidth: '180px' }}
										>
											<MenuItem value="">
												<em>Select commission</em>
											</MenuItem>
											{apiCommissionData.map((c) => (
												<MenuItem key={c.CommissionId} value={c.CommissionId}>
													{c.Name} ({getCommissionTypeDisplayLabel(c.Type)})
												</MenuItem>
											))}
										</Select>
									</TableCell>
									<TableCell padding="none">
										<TextField
											value={cRow.description || ''}
											onChange={(e) => handleCommissionDescriptionChange(e, ci)}
											placeholder="Description"
											size="small"
											variant="outlined"
											fullWidth
											inputProps={{ 'aria-label': 'Commission description' }}
										/>
									</TableCell>
									<TableCell padding="none" align="center">
										{valueMeta.enabled ? (
											<input
												type="number"
												name={valueMeta.name}
												value={cRow[valueMeta.name] ?? ''}
												onChange={(e) => handleCommissionValueChange(e, ci)}
												style={{ width: '120px', textAlign: 'right' }}
											/>
										) : (
											<span style={{ opacity: 0.5 }}>—</span>
										)}
										<div style={{ fontSize: '11px', color: '#666' }}>{valueMeta.label}</div>
									</TableCell>
									<TableCell padding="none" align="right">
										{(parseFloat(cRow.commissionAmount) || 0).toLocaleString(undefined, {
											minimumFractionDigits: 2,
											maximumFractionDigits: 2,
										})}
									</TableCell>
									<TableCell align="center">
										<Button className="mr10" onClick={() => handleCommissionConfirm(cRow.id)}>
											<DeleteOutlineIcon />
										</Button>
									</TableCell>
								</TableRow>
							);
						})}
					</TableBody>
				</Table>
				{showCommissionConfirm && (
					<Dialog open={showCommissionConfirm} onClose={handleCommissionConfirmNo}>
						<DialogTitle>Confirm Delete</DialogTitle>
						<DialogContent>
							<DialogContentText>Are you sure to delete this commission line?</DialogContentText>
						</DialogContent>
						<DialogActions>
							<Button onClick={handleCommissionRemove} color="primary" autoFocus>
								Yes
							</Button>
							<Button onClick={handleCommissionConfirmNo} color="primary">
								No
							</Button>
						</DialogActions>
					</Dialog>
				)}
			</div>
		)}

		{(() => {
			const hasCommission =
				formData.action === 'CheckOut' &&
				((Number(commissionTotal) || 0) > 0 ||
					(commissionRows || []).some(
						(c) => c.commissionId && (parseFloat(c.commissionAmount) || 0) > 0
					) ||
					(commissionRows || []).some((c) => c.commissionId));
			const displaySubtotal =
				(Number(invoiceSubtotal) || 0) > 0
					? Number(invoiceSubtotal)
					: (rows || []).reduce((sum, item) => sum + (parseFloat(item.totpri) || 0), 0);
			return (
		<div
			className={`checkout-totals-block${hasCommission ? ' checkout-totals-block--with-commission' : ''}`}
		>
			{hasCommission && (
				<h3>Subtotal: ${displaySubtotal.toLocaleString()}</h3>
			)}
			{SHOW_PAYMENT_FEE && formData.action === 'CheckOut' && (
				<h3>Payment Fee: ${paymentFee?.toLocaleString()}</h3>
			)}
			{hasCommission && (
				<h3>Commission Total: ${commissionTotal.toLocaleString()}</h3>
			)}
			<h3>Grand Total: ${grandTotal.toLocaleString()}</h3>
			<h3>
				Total Quantity:{' '}
				{(tranEdit != null ? parseFloat(getTotalQuantityEditMode() || 0) : totalQty).toLocaleString()}
			</h3>
		</div>
			);
		})()}
	
		
		<br></br>
       <div style={{   textAlign:"center" , paddingLeft:"130px" , marginTop:"20px"} }>
		<div style={{  marginTop:"30px" , textAlign:"center" , float:"left"} }>
				<Button type="button" onClick={handleSubmit} variant="contained" color="primary" >
					Submit
					</Button>
	   </div>  
	   { (tranAction =='edit' && formData?.action =='Reserve') && (
			<div  style={{  marginTop:"30px" , textAlign:"center" , float:"left",marginLeft:"10px",}}>
					<Button type="button" onClick={handleCancelConfirm} variant="contained" color="primary" >
						Cancel Reserve Order
						</Button>
				</div> 

	   )

	   }
	   </div>
      
	    <br/>
	    <br/>
		<br/>
	   {successMessage && (
        <div style={{ backgroundColor: '#28a745', color: '#fff', padding: '10px', marginTop: '10px' }}>
          {successMessage}
        </div>
      )}
	  {errorMessage && (
        <div style={{ backgroundColor: '#FF7F7F', color: '#fff', padding: '10px', marginTop: '10px', whiteSpace: 'pre-line' }}>
          {errorMessage}
        </div>
      )}

{showConfirmTargetPrice && (
					<div>
						<Dialog
							open={showConfirmTargetPrice}
							onClose={() => handleTargetPriceUpdate('No')}
							aria-labelledby="below-target-dialog-title"
							aria-describedby="below-target-dialog-description"
						>
							<DialogTitle id="below-target-dialog-title">
								Price Below Target Price
							</DialogTitle>
							<DialogContent>
								<DialogContentText id="below-target-dialog-description" component="div">
									<div>
										One or more items have a unit price below their recorded target price. Do you
										want to continue processing this invoice?
									</div>
									<ul style={{ marginTop: 12, paddingLeft: 20 }}>
										{belowTargetPriceWarningItems.map((item) => (
											<li key={`below-target-${item.index}-${item.itemnumber}`}>
												<strong>{item.itemnumber}</strong>
												{item.itemname ? ` — ${item.itemname}` : ''}: price $
												{item.unitPrice.toFixed(2)} &lt; target $
												{item.targetPrice.toFixed(2)}
											</li>
										))}
									</ul>
								</DialogContentText>
							</DialogContent>
							<DialogActions>
								<Button onClick={() => handleTargetPriceUpdate('No')} color="primary">
									Cancel
								</Button>
								<Button
									onClick={() => handleTargetPriceUpdate('Yes')}
									color="primary"
									variant="contained"
									autoFocus
								>
									{pendingBelowTargetSubmit ? 'Continue & Submit' : 'OK'}
								</Button>
							</DialogActions>
						</Dialog>
					</div>
					)} 

{showConfirmBelowCost && (
					<div>
						<Dialog
							open={showConfirmBelowCost}
							onClose={() => handleBelowCostConfirm(false)}
							aria-labelledby="below-cost-dialog-title"
							aria-describedby="below-cost-dialog-description"
						>
							<DialogTitle id="below-cost-dialog-title">
								Selling Below Cost
							</DialogTitle>
							<DialogContent>
								<DialogContentText id="below-cost-dialog-description" component="div">
									<div>
										One or more items have a unit price below their actual cost. Do you want to
										continue processing this invoice?
									</div>
									<ul style={{ marginTop: 12, paddingLeft: 20 }}>
										{belowCostWarningItems.map((item) => (
											<li key={`below-cost-${item.index}-${item.itemnumber}`}>
												<strong>{item.itemnumber}</strong>
												{item.itemname ? ` — ${item.itemname}` : ''}: price $
												{item.unitPrice.toFixed(2)} &lt; cost ${item.cost.toFixed(2)}
											</li>
										))}
									</ul>
								</DialogContentText>
							</DialogContent>
							<DialogActions>
								<Button onClick={() => handleBelowCostConfirm(false)} color="primary">
									Cancel
								</Button>
								<Button
									onClick={() => handleBelowCostConfirm(true)}
									color="primary"
									variant="contained"
									autoFocus
								>
									{pendingBelowCostSubmit ? 'Continue & Submit' : 'OK'}
								</Button>
							</DialogActions>
						</Dialog>
					</div>
				)}


{showTranDetail && ( 
					<div> 
						<Dialog  
						  fullWidth={fullWidthTrans}
						  maxWidth={maxWidthTrans}
						open={showTranDetail} 
						onClose={() => closeTransDetailDialog()} 
						style={{ height: '800px' }}
						> 
            <DialogTitle id="alert-dialog-title"> 
						<div style={{float:"left"}}>
            <IconButton
								aria-label="download"
								onClick={() => generatePdf()}
								sx={{
									position: "absolute",
									right: 8,
									top: 5,
									color: (theme) => theme.palette.grey[500]
								}}
								>
								 <CloudDownloadIcon />
								</IconButton>
					
						</div>
						<div style={{float:"right"}}>
						<IconButton
								aria-label="close"
								onClick={() => closeTransDetailDialog()}
								sx={{
									position: "absolute",
									right: 8,
									top: 5,
									color: (theme) => theme.palette.grey[500]
								}}
								>
								<CloseIcon />
								</IconButton>
						</div>
							
							
						</DialogTitle> 
					
						<DialogContent  ref={contentRef} id="alert-dialog-description"> 
							<DialogContentText > 
             <h2 style={{textAlign:"center"}} >Transaction Detail</h2>
              {isCheckoutInvoiceTicket() && (
                <div
                  ref={invoiceTypeToggleRef}
                  style={{ display: 'flex', justifyContent: 'center', margin: '8px 0 12px' }}
                >
                  <RadioGroup
                    row
                    value={invoiceType}
                    onChange={(e) => setInvoiceType(e.target.value)}
                  >
                    <FormControlLabel
                      value="internal"
                      control={<Radio color="primary" />}
                      label="Internal Invoice"
                    />
                    <FormControlLabel
                      value="client"
                      control={<Radio color="primary" />}
                      label="Client Invoice"
                    />
                  </RadioGroup>
                </div>
              )}
			  <TransactionHeader
				ticketNumber={tranDetail.TicketNumber}
				recipientName={tranDetail.CustomerName || tranDetail.VendorName}
				date={moment(formData.date).format('MM-DD-YYYY')}
				userName={userName}
				showBrokers={isCheckoutInvoiceTicket() && invoiceType === 'internal'}
				brokers={[1, 2, 3].map((brokerNumber) => ({
					number: brokerNumber,
					name: tranDetail[`Broker${brokerNumber}Name`],
				}))}
			  />
							<TableContainer>
								<div
								 ref={gridRef}
								 style={{
								   height: "300px", // Restrict height to make it scrollable
								   overflow: "auto"
								 }}
					 
								>

							
                  <Table>
                    <TableHead>
                      <TableRow style={{ backgroundColor: '#f5f5f5' }}>
                        <TableCell style={{ fontWeight: 600, fontSize: '14px', color: 'rgba(0,0,0,0.87)' }}>Item Number</TableCell>
                        <TableCell style={{ fontWeight: 600, fontSize: '14px', color: 'rgba(0,0,0,0.87)' }}>Item Name</TableCell>
                        <TableCell style={{ fontWeight: 600, fontSize: '14px', color: 'rgba(0,0,0,0.87)', textAlign: 'right' }}>Quantity</TableCell>
	                        <TableCell style={{ fontWeight: 600, fontSize: '14px', color: 'rgba(0,0,0,0.87)', textAlign: 'right' }}>{showInternalInvoiceAccounting() ? 'Sales Price' : 'Price'}</TableCell>
	                        <TableCell style={{ fontWeight: 600, fontSize: '14px', color: 'rgba(0,0,0,0.87)', textAlign: 'right' }}>{showInternalInvoiceAccounting() ? 'Total Sales' : 'Total'}</TableCell>
	                        {showInternalInvoiceAccounting() && (
	                          <>
	                            <TableCell style={{ fontWeight: 600, fontSize: '14px', color: 'rgba(0,0,0,0.87)', textAlign: 'right' }}>Cost</TableCell>
	                            <TableCell style={{ fontWeight: 600, fontSize: '14px', color: 'rgba(0,0,0,0.87)', textAlign: 'right' }}>CP Commission</TableCell>
	                            <TableCell style={{ fontWeight: 600, fontSize: '14px', color: 'rgba(0,0,0,0.87)', textAlign: 'right' }}>QB Total</TableCell>
	                          </>
	                        )}
	                      </TableRow>
                    </TableHead>
					<TableBody>
					  <InvoiceLineRows
						items={getTranDetailDisplayItems()}
						grouped={isCheckoutInvoiceTicket() && invoiceType === 'internal'}
						getEntityGroupName={getItemEntityGroupName}
						getItemNumber={(item) => item.itemnumber}
						getItemName={(item) => item.itemname}
						getQuantity={(item) => item.checkoutqty}
							getUnitPrice={(item) => item.priperunit}
							getTotalPrice={(item) => item.totpri}
							getUnitCost={(item) => resolveRowUnitCostForCommission(item, apiItemData)}
							getRowKey={(item, idx) => item.itemid || item.itemnumber || idx}
							showAccountingColumns={showInternalInvoiceAccounting()}
							commissions={(tranDetail && tranDetail.commissions) || []}
						  />
					</TableBody>
                    <TableFooter style={{ height: '100%'}} >
						{isCheckoutInvoiceTicket() &&
							!showInternalInvoiceAccounting() &&
							(((tranDetail?.commissions || []).length > 0) ||
							(parseFloat(tranDetail?.TotalCommission) || 0) > 0) && (
					<TableRow>
                        <TableCell style={{ borderBottom: '0px none'}}></TableCell>
                        <TableCell style={{ borderBottom: '0px none'}}></TableCell>
                        <TableCell style={{ borderBottom: '0px none'}}></TableCell>
                        <TableCell style={{ borderBottom: '0px none',fontStyle:"normal", fontSize:"16px",textAlign:"right"}}><b>Subtotal :</b></TableCell>
                        <TableCell style={{ borderBottom: '0px none',fontStyle:"normal", fontSize:"16px",textAlign:"right"}}> <b>${(getTranDetailDisplayTotals().itemSubtotal || 0).toLocaleString()}</b></TableCell>
                      </TableRow>
					)}
					    <TableRow>
					        <TableCell colSpan={showInternalInvoiceAccounting() ? 6 : 3} style={{ borderBottom: '0px none'}} />
					        <TableCell style={{ borderBottom: '0px none',fontStyle:"normal", fontSize:"16px",textAlign:"right"}}><b>Total Quantity:</b></TableCell>
                        <TableCell style={{ borderBottom: '0px none',fontStyle:"normal", fontSize:"16px",textAlign:"right"}}> <b>{getTotalQuantity().toLocaleString()}</b></TableCell>
                      </TableRow>
					{SHOW_PAYMENT_FEE && (formData.action =='CheckOut')&&(
							<TableRow>
					        <TableCell colSpan={showInternalInvoiceAccounting() ? 6 : 3} style={{ borderBottom: '0px none'}} />
					        <TableCell style={{ borderBottom: '0px none',fontStyle:"normal", fontSize:"16px",textAlign:"right"}}><b>Payment Fee :</b></TableCell>
                        <TableCell style={{ borderBottom: '0px none',fontStyle:"normal", fontSize:"16px",textAlign:"right"}}> <b>${getTranDetailDisplayTotals().totalPaymentFee.toLocaleString()}</b></TableCell>
                      </TableRow>
					)}
						  <TableRow>
					        <TableCell colSpan={showInternalInvoiceAccounting() ? 6 : 3} style={{ borderBottom: '0px none'}} />
                        <TableCell style={{ borderBottom: '0px none',fontStyle:"normal", fontSize:"16px",textAlign:"right"}}><b>Grand Total :</b></TableCell>
                        <TableCell style={{ borderBottom: '0px none',fontStyle:"normal", fontSize:"16px",textAlign:"right"}}> <b>${getTranDetailDisplayTotals().totalTicketPrice.toLocaleString()}</b></TableCell>
                      </TableRow>
                      

                    </TableFooter>
                  </Table>
				  </div>
                  <br/>
                  <br/>
                 
                </TableContainer>
							</DialogContentText> 
						</DialogContent> 
						<DialogActions> 
							
							
						</DialogActions> 
						</Dialog> 
            
					</div> 
					)} 
{showCancelConfirm && ( 
					<div> 
						<Dialog 
						open={showCancelConfirm} 
						onClose={handleCancelConfirm} 
						aria-labelledby="alert-dialog-title"
						aria-describedby="alert-dialog-description"
						> 
						<DialogTitle id="alert-dialog-title"> 
							{"Confirm Cancel Reserve Order"} 
						</DialogTitle> 
						<DialogContent> 
							<DialogContentText id="alert-dialog-description"> 
							Are you sure to Cancel Reserve Order?
							</DialogContentText> 
						</DialogContent> 
						<DialogActions> 
							<Button 
              onClick={handleCancelReserveOrder} 
							color="primary"
							autoFocus 
							> 
							Yes 
							</Button> 
							<Button 
							onClick={handleCloseConfirm} 
							color="primary"
							autoFocus 
							> 
							No 
							</Button> 
						</DialogActions> 
						</Dialog> 
					</div> 
					)} 
   
      </div>	
	</Box> 
	</TableBody> 
	
	{loading ? <Spinner /> :""}
	
	</div>
); 
} 

export default CheckOut;
